/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
};

export type ApplicationStage = {
  __typename?: 'ApplicationStage';
  completed: Scalars['Boolean']['output'];
  current: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ApplyJobRequest = {
  job_id: Scalars['Int']['input'];
};

export type ApplyJobResponse = {
  __typename?: 'ApplyJobResponse';
  success: Scalars['Boolean']['output'];
};

export enum AttachmentType {
  AwardCertificate = 'AWARD_CERTIFICATE',
  CompetencyCertificate = 'COMPETENCY_CERTIFICATE',
  Degree = 'DEGREE',
  FamilyCard = 'FAMILY_CARD',
  HealthTestResult = 'HEALTH_TEST_RESULT',
  IdentityCard = 'IDENTITY_CARD',
  Language = 'LANGUAGE',
  Other = 'OTHER',
  Passport = 'PASSPORT',
  Resume = 'RESUME'
}

export type BaseSuccessResponse = {
  __typename?: 'BaseSuccessResponse';
  success: Scalars['Boolean']['output'];
};

export enum BloodType {
  A = 'A',
  Ab = 'AB',
  B = 'B',
  O = 'O'
}

export type CoderByteMetadata = {
  __typename?: 'CoderByteMetadata';
  public_url: Scalars['String']['output'];
  test_id: Scalars['String']['output'];
};

export type DeleteJobCategoryResponse = {
  __typename?: 'DeleteJobCategoryResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteJobCompanyResponse = {
  __typename?: 'DeleteJobCompanyResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteJobResponse = {
  __typename?: 'DeleteJobResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteJobSkillResponse = {
  __typename?: 'DeleteJobSkillResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteJobTagResponse = {
  __typename?: 'DeleteJobTagResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteMasterJobSelectionPhaseResponse = {
  __typename?: 'DeleteMasterJobSelectionPhaseResponse';
  success: Scalars['Boolean']['output'];
};

export enum DriverLicense {
  A = 'A',
  B1 = 'B1'
}

export type EWallet = {
  __typename?: 'EWallet';
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum EducationLevel {
  Bachelor = 'BACHELOR',
  Diploma_1 = 'DIPLOMA_1',
  Diploma_2 = 'DIPLOMA_2',
  Diploma_3 = 'DIPLOMA_3',
  Diploma_4 = 'DIPLOMA_4',
  Doctoral = 'DOCTORAL',
  JuniorHighSchool = 'JUNIOR_HIGH_SCHOOL',
  Master = 'MASTER',
  SeniorHighSchool = 'SENIOR_HIGH_SCHOOL',
  VocationalHighSchool = 'VOCATIONAL_HIGH_SCHOOL'
}

export enum EmploymentType {
  Apprenticeship = 'APPRENTICESHIP',
  Contract = 'CONTRACT',
  Freelance = 'FREELANCE',
  FullTime = 'FULL_TIME',
  Internship = 'INTERNSHIP',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED'
}

export enum Gender {
  Men = 'MEN',
  Women = 'WOMEN'
}

export type GeoDbCity = {
  __typename?: 'GeoDBCity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GeoDbCountry = {
  __typename?: 'GeoDBCountry';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GeoDbProvince = {
  __typename?: 'GeoDBProvince';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GetCitiesRequest = {
  country_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  province_id: Scalars['String']['input'];
};

export type GetCitiesResponse = {
  __typename?: 'GetCitiesResponse';
  data: Array<GeoDbCity>;
};

export type GetCountriesRequest = {
  name: Scalars['String']['input'];
};

export type GetCountriesResponse = {
  __typename?: 'GetCountriesResponse';
  data: Array<GeoDbCountry>;
};

export type GetHrdRoomGetActivationCodeResponse = {
  __typename?: 'GetHRDRoomGetActivationCodeResponse';
  data: Array<HrdRoomGetActivationCode>;
};

export type GetHrdRoomModulesResponse = {
  __typename?: 'GetHRDRoomModulesResponse';
  data: Array<HrdRoomModule>;
};

export type GetJobCategoryDetailResponse = {
  __typename?: 'GetJobCategoryDetailResponse';
  data?: Maybe<JobCategory>;
};

export type GetJobCategoryResponse = {
  __typename?: 'GetJobCategoryResponse';
  data: Array<JobCategory>;
};

export type GetJobCompanyDetailResponse = {
  __typename?: 'GetJobCompanyDetailResponse';
  data?: Maybe<JobCompany>;
};

export type GetJobCompanyResponse = {
  __typename?: 'GetJobCompanyResponse';
  data: Array<JobCompany>;
};

export type GetJobDetailResponse = {
  __typename?: 'GetJobDetailResponse';
  data?: Maybe<Job>;
};

export type GetJobResponse = {
  __typename?: 'GetJobResponse';
  data: Array<Job>;
};

export type GetJobSkillDetailResponse = {
  __typename?: 'GetJobSkillDetailResponse';
  data?: Maybe<JobSkill>;
};

export type GetJobSkillResponse = {
  __typename?: 'GetJobSkillResponse';
  data: Array<JobSkill>;
};

export type GetJobTagDetailResponse = {
  __typename?: 'GetJobTagDetailResponse';
  data?: Maybe<JobTag>;
};

export type GetJobTagResponse = {
  __typename?: 'GetJobTagResponse';
  data: Array<JobTag>;
};

export type GetJobUserDetailResponse = {
  __typename?: 'GetJobUserDetailResponse';
  data?: Maybe<JobUser>;
};

export type GetJobUserResponse = {
  __typename?: 'GetJobUserResponse';
  data: Array<JobUser>;
};

export type GetJobUserSelectionPhaseHrdRoomResponse = {
  __typename?: 'GetJobUserSelectionPhaseHRDRoomResponse';
  data: JobUserSelectionPhaseHrdRoom;
};

export type GetMasterJobSelectionPhaseDetailResponse = {
  __typename?: 'GetMasterJobSelectionPhaseDetailResponse';
  data?: Maybe<MasterJobSelectionPhase>;
};

export type GetMasterJobSelectionPhaseResponse = {
  __typename?: 'GetMasterJobSelectionPhaseResponse';
  data: Array<MasterJobSelectionPhase>;
};

export type GetProfileResponse = {
  __typename?: 'GetProfileResponse';
  user: User;
};

export type GetProvincesRequest = {
  country_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type GetProvincesResponse = {
  __typename?: 'GetProvincesResponse';
  data: Array<GeoDbProvince>;
};

export type GetUserAttachmentResponse = {
  __typename?: 'GetUserAttachmentResponse';
  data: Array<UserAttachment>;
};

export type GetUserEducationResponse = {
  __typename?: 'GetUserEducationResponse';
  data: Array<UserEducation>;
};

export type GetUserExperienceResponse = {
  __typename?: 'GetUserExperienceResponse';
  data: Array<UserExperience>;
};

export type GetUserFamilyResponse = {
  __typename?: 'GetUserFamilyResponse';
  data: Array<UserFamily>;
};

export type GetUserHealthResponse = {
  __typename?: 'GetUserHealthResponse';
  data: Array<UserHealth>;
};

export type GetUserLanguageResponse = {
  __typename?: 'GetUserLanguageResponse';
  data: Array<UserLanguage>;
};

export type GetUserParticipantResponse = {
  __typename?: 'GetUserParticipantResponse';
  data: User;
};

export type GetUserPersonalInfoResponse = {
  __typename?: 'GetUserPersonalInfoResponse';
  data: UserPersonalInfo;
};

export type GetUserProgressResponse = {
  __typename?: 'GetUserProgressResponse';
  data: UserProgress;
};

export type GetUserResumeResponse = {
  __typename?: 'GetUserResumeResponse';
  data?: Maybe<UserAttachment>;
};

export type GoogleLoginRequest = {
  access_token: Scalars['String']['input'];
  refferal_code?: InputMaybe<Scalars['String']['input']>;
};

export type GoogleLoginResponse = {
  __typename?: 'GoogleLoginResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type HrdRoomGetActivationCode = {
  __typename?: 'HRDRoomGetActivationCode';
  campaign: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  created_by: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expired_at?: Maybe<Scalars['String']['output']>;
  geo_location: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  module_id: Scalars['Int']['output'];
  module_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  start_from: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type HrdRoomGetActivationCodeDetail = {
  __typename?: 'HRDRoomGetActivationCodeDetail';
  name: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  selection_status: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type HrdRoomModule = {
  __typename?: 'HRDRoomModule';
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  published: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type HealthCheckResponse = {
  __typename?: 'HealthCheckResponse';
  success: Scalars['Boolean']['output'];
};

export enum HealthStatus {
  AlreadyHealed = 'ALREADY_HEALED',
  InRecovery = 'IN_RECOVERY',
  NeverBeenSevereIllness = 'NEVER_BEEN_SEVERE_ILLNESS',
  StillSick = 'STILL_SICK'
}

export type Job = {
  __typename?: 'Job';
  categories?: Maybe<Array<JobCategory>>;
  city: GeoDbCity;
  country: GeoDbCountry;
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  is_applied: Scalars['Boolean']['output'];
  is_bookmark: Scalars['Boolean']['output'];
  job_company?: Maybe<JobCompany>;
  job_company_id: Scalars['Int']['output'];
  job_selection_phase: Array<JobSelectionPhase>;
  job_skills?: Maybe<Array<JobSkill>>;
  location_city_id?: Maybe<Scalars['String']['output']>;
  location_country_id?: Maybe<Scalars['String']['output']>;
  location_province_id?: Maybe<Scalars['String']['output']>;
  location_type: JobLocationType;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  province: GeoDbProvince;
  salary_currency: Scalars['String']['output'];
  salary_period: JobSalaryPeriod;
  tags?: Maybe<Array<JobTag>>;
  title: Scalars['String']['output'];
  type: JobType;
  updated_at: Scalars['String']['output'];
};

export type JobCategory = {
  __typename?: 'JobCategory';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type JobCompany = {
  __typename?: 'JobCompany';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobs?: Maybe<Array<Job>>;
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size_from: Scalars['Int']['output'];
  size_to: Scalars['Int']['output'];
  updated_at: Scalars['String']['output'];
};

export type JobHistoryUser = {
  __typename?: 'JobHistoryUser';
  appliedDate: Scalars['String']['output'];
  company: Scalars['String']['output'];
  currentStage: Scalars['String']['output'];
  currentStep: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  partnerType: Scalars['String']['output'];
  position: Scalars['String']['output'];
  stages: Array<ApplicationStage>;
  status: Scalars['String']['output'];
  totalSteps: Scalars['Int']['output'];
};

export type JobHistoryUserResponse = {
  __typename?: 'JobHistoryUserResponse';
  data: Array<JobHistoryUser>;
};

export enum JobLocationType {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Remote = 'REMOTE'
}

export enum JobSalaryPeriod {
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type JobSelectionPhase = {
  __typename?: 'JobSelectionPhase';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_id: Scalars['Int']['output'];
  master_job_selection_phase: MasterJobSelectionPhase;
  master_job_selection_phase_id: Scalars['Int']['output'];
  phase_number: Scalars['Int']['output'];
  required_application_document: Array<Maybe<Scalars['String']['output']>>;
  updated_at: Scalars['String']['output'];
};

export type JobSkill = {
  __typename?: 'JobSkill';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type JobTag = {
  __typename?: 'JobTag';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export enum JobType {
  Apprenticeship = 'APPRENTICESHIP',
  Contract = 'CONTRACT',
  Freelance = 'FREELANCE',
  FullTime = 'FULL_TIME',
  Internship = 'INTERNSHIP',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type JobUser = {
  __typename?: 'JobUser';
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job: Job;
  job_id: Scalars['Int']['output'];
  job_user_selection_phase: Array<JobUserSelectionPhase>;
  last_job_user_selection_phase?: Maybe<JobUserSelectionPhase>;
  updated_at: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
};

export type JobUserPreview = {
  __typename?: 'JobUserPreview';
  aiRecommender?: Maybe<JobUserSelectionPhaseAiRecommender>;
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  jobId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  title: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type JobUserSelectionPhase = {
  __typename?: 'JobUserSelectionPhase';
  ai_recommender?: Maybe<JobUserSelectionPhaseAiRecommender>;
  coderbyte_metadata?: Maybe<CoderByteMetadata>;
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job_selection_phase: JobSelectionPhase;
  job_selection_phase_id: Scalars['Int']['output'];
  job_user: JobUser;
  job_user_id: Scalars['Int']['output'];
  job_user_selection_phase_hrdroom?: Maybe<JobUserSelectionPhaseHrdRoom>;
  score?: Maybe<Scalars['Int']['output']>;
  status: JobUserSelectionPhaseStatus;
  updated_at: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type JobUserSelectionPhaseAiRecommender = {
  __typename?: 'JobUserSelectionPhaseAIRecommender';
  ai_notes?: Maybe<Scalars['String']['output']>;
  ai_score?: Maybe<Scalars['Int']['output']>;
  is_recommended_by_ai: Scalars['Boolean']['output'];
};

export type JobUserSelectionPhaseHrdRoom = {
  __typename?: 'JobUserSelectionPhaseHRDRoom';
  activation_code?: Maybe<HrdRoomGetActivationCode>;
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  expired_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  job_user_selection_phase_id: Scalars['Int']['output'];
  module?: Maybe<HrdRoomModule>;
  module_id: Scalars['Int']['output'];
  test?: Maybe<HrdRoomGetActivationCodeDetail>;
  test_token: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum JobUserSelectionPhaseStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type JobUsersPageReq = {
  jobId?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobUsersPageRes = {
  __typename?: 'JobUsersPageRes';
  data: Array<JobUserPreview>;
  page: PageInfo;
};

export enum Language {
  English = 'ENGLISH',
  Indonesia = 'INDONESIA',
  Japanese = 'JAPANESE',
  None = 'NONE'
}

export enum LanguageLevel {
  A1Beginner = 'A1_BEGINNER',
  A2Elementary = 'A2_ELEMENTARY',
  B1Intermediate = 'B1_INTERMEDIATE',
  B2UpperIntermediate = 'B2_UPPER_INTERMEDIATE',
  Beginner = 'BEGINNER',
  C1Advanced = 'C1_ADVANCED',
  C2Proficient = 'C2_PROFICIENT',
  Intermediate = 'INTERMEDIATE',
  N1Advanced = 'N1_ADVANCED',
  N2UpperIntermediate = 'N2_UPPER_INTERMEDIATE',
  N3Intermediate = 'N3_INTERMEDIATE',
  N4Elementary = 'N4_ELEMENTARY',
  N5Beginner = 'N5_BEGINNER',
  Native = 'NATIVE'
}

export enum LocationType {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Remote = 'REMOTE'
}

export type LoginRequest = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  user: User;
};

export enum MaritalStatus {
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Single = 'SINGLE'
}

export type MasterJobSelectionPhase = {
  __typename?: 'MasterJobSelectionPhase';
  ai_cv_recommender: Scalars['Boolean']['output'];
  created_at: Scalars['String']['output'];
  deleted_at?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  hrd_room: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  phase: Scalars['String']['output'];
  updated_at: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  applyJob: ApplyJobResponse;
  changeStatusJobUserSelection: ChangeStatusJobUserSelectionResponse;
  deleteJob: DeleteJobResponse;
  deleteJobCategory: DeleteJobCategoryResponse;
  deleteJobCompany: DeleteJobCompanyResponse;
  deleteJobSkill: DeleteJobSkillResponse;
  deleteJobTag: DeleteJobTagResponse;
  deleteMasterJobSelectionPhase: DeleteMasterJobSelectionPhaseResponse;
  googleLogin: GoogleLoginResponse;
  healthCheck: HealthCheckResponse;
  login: LoginResponse;
  register: RegisterResponse;
  resetPassword: ResetPasswordResponse;
  resubmitUserStatusProfile: ResubmitUserStatusProfileResponse;
  sendOTP: SendOtpResponse;
  sendResetLink: SendResetLinkResponse;
  sentHRDRoomTestToken: SentHrdRoomTestTokenResponse;
  updateJobBookmark: BaseSuccessResponse;
  updateUser: UpdateUserResponse;
  upsertAffiliator: ResetPasswordResponse;
  upsertJob: UpsertJobResponse;
  upsertJobCategory: UpsertJobCategoryResponse;
  upsertJobSkill: UpsertJobSkillResponse;
  upsertJobTag: UpsertJobTagResponse;
  upsertMasterJobSelectionPhase: UpsertMasterJobSelectionPhaseResponse;
  upsertPoinExchangeHistory: ResetPasswordResponse;
  upsertUserCV: UpsertUserStatusProfileResponse;
  upsertUserEducation: UpsertUserEducationResponse;
  upsertUserExperience: UpsertUserExperienceResponse;
  upsertUserFamily: UpsertUserFamilyResponse;
  upsertUserHealth: UpsertUserHealthResponse;
  upsertUserStatusProfile: UpsertUserStatusProfileResponse;
  verifyOTP: VerifyOtpResponse;
};


export type MutationApplyJobArgs = {
  request: ApplyJobRequest;
};


export type MutationChangeStatusJobUserSelectionArgs = {
  request: ChangeStatusJobUserSelectionRequest;
};


export type MutationDeleteJobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteJobCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteJobCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteJobSkillArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteJobTagArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteMasterJobSelectionPhaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationGoogleLoginArgs = {
  request: GoogleLoginRequest;
};


export type MutationLoginArgs = {
  request: LoginRequest;
};


export type MutationRegisterArgs = {
  request: RegisterRequest;
};


export type MutationResetPasswordArgs = {
  request: ResetPasswordRequest;
};


export type MutationSendOtpArgs = {
  request: SendOtpRequest;
};


export type MutationSendResetLinkArgs = {
  request: SendResetLinkRequest;
};


export type MutationSentHrdRoomTestTokenArgs = {
  request: SentHrdRoomTestTokenRequest;
};


export type MutationUpdateJobBookmarkArgs = {
  jobId: Scalars['Int']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationUpdateUserArgs = {
  request: UpdateUserRequest;
};


export type MutationUpsertAffiliatorArgs = {
  request: UpsertAffiliatorRequest;
};


export type MutationUpsertJobArgs = {
  request: UpsertJobRequest;
};


export type MutationUpsertJobCategoryArgs = {
  request: UpsertJobCategoryRequest;
};


export type MutationUpsertJobSkillArgs = {
  request: UpsertJobSkillRequest;
};


export type MutationUpsertJobTagArgs = {
  request: UpsertJobTagRequest;
};


export type MutationUpsertMasterJobSelectionPhaseArgs = {
  request: UpsertMasterJobSelectionPhaseRequest;
};


export type MutationUpsertPoinExchangeHistoryArgs = {
  data: UpsertPointExchangeHistoryInput;
};


export type MutationUpsertUserCvArgs = {
  request: UpsertUserCvRequest;
};


export type MutationUpsertUserEducationArgs = {
  request: UpsertUserEducationRequest;
};


export type MutationUpsertUserExperienceArgs = {
  request: UpsertUserExperienceRequest;
};


export type MutationUpsertUserFamilyArgs = {
  request: UpsertUserFamilyRequest;
};


export type MutationUpsertUserHealthArgs = {
  request: UpsertUserHealthRequest;
};


export type MutationUpsertUserStatusProfileArgs = {
  request: Array<UpsertUserStatusProfileRequest>;
};


export type MutationVerifyOtpArgs = {
  request: VerifyOtpRequest;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  page: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Pagination = {
  __typename?: 'Pagination';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationInput = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type PointExchangeHistory = {
  __typename?: 'PointExchangeHistory';
  created_at: Scalars['String']['output'];
  ewallet: EWallet;
  ewallet_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  no_hp: Scalars['String']['output'];
  point: Scalars['Int']['output'];
  status: PointExchangeHistoryStatus;
  user: User;
  user_id: Scalars['Int']['output'];
};

export enum PointExchangeHistoryStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Ongoing = 'ONGOING'
}

export enum PossibleDurationToStayInJapan {
  LearnMore = 'LEARN_MORE',
  PossibleDurationToStayInJapan = 'POSSIBLE_DURATION_TO_STAY_IN_JAPAN',
  Three_5Tahun = 'THREE_5_TAHUN',
  ThreeTahun = 'THREE_TAHUN'
}

export type Query = {
  __typename?: 'Query';
  detailUserAffiliatedCount: UserAffiliatedCountResponse;
  generateJapaneseCV: GenerateJapaneseCv;
  getAffiliator: Array<User>;
  getCities: GetCitiesResponse;
  getCountries: GetCountriesResponse;
  getJob: GetJobResponse;
  getJobCategory: GetJobCategoryResponse;
  getJobCategoryDetail: GetJobCategoryDetailResponse;
  getJobCompany: GetJobCompanyResponse;
  getJobCompanyDetail: GetJobCompanyDetailResponse;
  getJobDetail: GetJobDetailResponse;
  getJobSkill: GetJobSkillResponse;
  getJobSkillDetail: GetJobSkillDetailResponse;
  getJobTag: GetJobTagResponse;
  getJobTagDetail: GetJobTagDetailResponse;
  getJobUser: GetJobUserResponse;
  getJobUserDetail: GetJobUserDetailResponse;
  getJobUserSelectionPhaseHRDRoom: GetJobUserSelectionPhaseHrdRoomResponse;
  getListEwallet: Array<EWallet>;
  getMasterJobSelectionPhase: GetMasterJobSelectionPhaseResponse;
  getMasterJobSelectionPhaseDetail: GetMasterJobSelectionPhaseDetailResponse;
  getPointExchangeHistory: Array<PointExchangeHistory>;
  getProfile: GetProfileResponse;
  getProvinces: GetProvincesResponse;
  getStatusJobVacancyUser?: Maybe<GetJobUserDetailResponse>;
  getUserAttachment: GetUserAttachmentResponse;
  getUserCV: GetUserCvResponse;
  getUserEducation: GetUserEducationResponse;
  getUserExperience: GetUserExperienceResponse;
  getUserFamily: GetUserFamilyResponse;
  getUserHealth: GetUserHealthResponse;
  getUserLanguage: GetUserLanguageResponse;
  getUserParticipant: GetUserParticipantResponse;
  getUserPersonalInfo: GetUserPersonalInfoResponse;
  getUserProgress: GetUserProgressResponse;
  getUserResume: GetUserResumeResponse;
  healthCheck: HealthCheckResponse;
  hrdroomGetModules: GetHrdRoomModulesResponse;
  hrdroomGetTests: GetHrdRoomGetActivationCodeResponse;
  jobHistoryUser: JobHistoryUserResponse;
  jobUsersPage: JobUsersPageRes;
  listUserAffiliated: Array<User>;
  searchUserParticipant: SearchUserParticipantResponse;
  searchUserParticipantV2: SearchUserParticipantResponseV2;
};


export type QueryDetailUserAffiliatedCountArgs = {
  refferal_code: Scalars['String']['input'];
  user_id: Scalars['Int']['input'];
};


export type QueryGetCitiesArgs = {
  request: GetCitiesRequest;
};


export type QueryGetCountriesArgs = {
  request: GetCountriesRequest;
};


export type QueryGetJobArgs = {
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobCategoryArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobCategoryDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobCompanyArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobCompanyDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobSkillArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobSkillDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobTagArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetJobTagDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobUserArgs = {
  job_id?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SearchUserParticipantRequest>;
};


export type QueryGetJobUserDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetJobUserSelectionPhaseHrdRoomArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetMasterJobSelectionPhaseDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGetProvincesArgs = {
  request: GetProvincesRequest;
};


export type QueryGetUserParticipantArgs = {
  user_id: Scalars['Int']['input'];
};


export type QueryGetUserProgressArgs = {
  is_simplify?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHrdroomGetTestsArgs = {
  module_id: Scalars['Int']['input'];
};


export type QueryJobUsersPageArgs = {
  req: JobUsersPageReq;
};


export type QueryListUserAffiliatedArgs = {
  refferal_code: Scalars['String']['input'];
};


export type QuerySearchUserParticipantArgs = {
  request?: InputMaybe<SearchUserParticipantRequest>;
};


export type QuerySearchUserParticipantV2Args = {
  request?: InputMaybe<SearchUserParticipantRequestV2>;
};

export type RegisterRequest = {
  email: Scalars['String']['input'];
  handphone_number: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  refferal_code?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  token: Scalars['String']['output'];
  user: User;
};

export enum Relation {
  BigBrother = 'BIG_BROTHER',
  BigSister = 'BIG_SISTER',
  Cousin = 'COUSIN',
  Daughter = 'DAUGHTER',
  Father = 'FATHER',
  Husband = 'HUSBAND',
  LittleBrother = 'LITTLE_BROTHER',
  LittleSister = 'LITTLE_SISTER',
  Mother = 'MOTHER',
  Son = 'SON',
  Wife = 'WIFE'
}

export enum Religion {
  Buddhism = 'BUDDHISM',
  Confucianism = 'CONFUCIANISM',
  Hinduism = 'HINDUISM',
  Islam = 'ISLAM',
  Protestantism = 'PROTESTANTISM',
  RomanCatholic = 'ROMAN_CATHOLIC'
}

export type ResetPasswordRequest = {
  new_password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  success: Scalars['Boolean']['output'];
};

export type ResubmitUserStatusProfileResponse = {
  __typename?: 'ResubmitUserStatusProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type SearchUserParticipantRequest = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  education_level?: InputMaybe<EducationLevel>;
  end_apply_date?: InputMaybe<Scalars['String']['input']>;
  end_register_date?: InputMaybe<Scalars['String']['input']>;
  is_recommended_by_ai?: InputMaybe<Scalars['Boolean']['input']>;
  marital_status?: InputMaybe<MaritalStatus>;
  max_age?: InputMaybe<Scalars['Int']['input']>;
  min_age?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_apply_date?: InputMaybe<Scalars['String']['input']>;
  start_register_date?: InputMaybe<Scalars['String']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  total_experience_in_months?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchUserParticipantRequestV2 = {
  company_id?: InputMaybe<Scalars['Int']['input']>;
  education_level?: InputMaybe<EducationLevel>;
  end_apply_date?: InputMaybe<Scalars['String']['input']>;
  end_register_date?: InputMaybe<Scalars['String']['input']>;
  is_recommended_by_ai?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  marital_status?: InputMaybe<MaritalStatus>;
  max_age?: InputMaybe<Scalars['Int']['input']>;
  min_age?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  start_apply_date?: InputMaybe<Scalars['String']['input']>;
  start_register_date?: InputMaybe<Scalars['String']['input']>;
  tag_id?: InputMaybe<Scalars['Int']['input']>;
  total_experience_in_months?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchUserParticipantResponse = {
  __typename?: 'SearchUserParticipantResponse';
  data: Array<User>;
};

export type SearchUserParticipantResponseV2 = {
  __typename?: 'SearchUserParticipantResponseV2';
  data: Array<User>;
  pagination: Pagination;
};

export type SendOtpRequest = {
  sent_by: UserOtpSentBy;
};

export type SendOtpResponse = {
  __typename?: 'SendOTPResponse';
  success: Scalars['Boolean']['output'];
};

export type SendResetLinkRequest = {
  email: Scalars['String']['input'];
};

export type SendResetLinkResponse = {
  __typename?: 'SendResetLinkResponse';
  success: Scalars['Boolean']['output'];
};

export type SentHrdRoomTestTokenRequest = {
  job_user_selection_phase_id: Scalars['Int']['input'];
  module_id: Scalars['Int']['input'];
  test_id: Scalars['Int']['input'];
};

export type SentHrdRoomTestTokenResponse = {
  __typename?: 'SentHRDRoomTestTokenResponse';
  success: Scalars['Boolean']['output'];
};

export enum SpouseResponsibility {
  No = 'NO',
  Yes = 'YES'
}

export enum StatusProfile {
  FillingSubmissionStage = 'FILLING_SUBMISSION_STAGE',
  SubmissionApproved = 'SUBMISSION_APPROVED',
  SubmissionRejected = 'SUBMISSION_REJECTED',
  SubmissionVerificationStage = 'SUBMISSION_VERIFICATION_STAGE'
}

export type UpdateStatusJobUserSelectionPhaseRequest = {
  id: Scalars['Int']['input'];
  status: JobUserSelectionPhaseStatus;
};

export type UpdateUserRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  handphone_number?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserResponse = {
  __typename?: 'UpdateUserResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertAffiliatorRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertJobCategoryRequest = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertJobCategoryResponse = {
  __typename?: 'UpsertJobCategoryResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertJobRequest = {
  category_ids: Array<Scalars['Int']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  is_active: Scalars['Boolean']['input'];
  job_company_id: Scalars['Int']['input'];
  job_selection_phase: Array<UpsertJobSelectionPhase>;
  location_city_id?: InputMaybe<Scalars['String']['input']>;
  location_country_id?: InputMaybe<Scalars['String']['input']>;
  location_province_id?: InputMaybe<Scalars['String']['input']>;
  location_type: JobLocationType;
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  salary_currency: Scalars['String']['input'];
  salary_period: JobSalaryPeriod;
  skill_ids: Array<Scalars['Int']['input']>;
  tag_ids: Array<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  type: JobType;
};

export type UpsertJobResponse = {
  __typename?: 'UpsertJobResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertJobSelectionPhase = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  master_job_selection_phase_id: Scalars['Int']['input'];
  phase_number: Scalars['Int']['input'];
  required_application_document: Array<InputMaybe<Scalars['String']['input']>>;
};

export type UpsertJobSkillRequest = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertJobSkillResponse = {
  __typename?: 'UpsertJobSkillResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertJobTagRequest = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type UpsertJobTagResponse = {
  __typename?: 'UpsertJobTagResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertMasterJobSelectionPhaseRequest = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  phase: Scalars['String']['input'];
};

export type UpsertMasterJobSelectionPhaseResponse = {
  __typename?: 'UpsertMasterJobSelectionPhaseResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertPointExchangeHistoryInput = {
  ewallet_id: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  no_hp: Scalars['String']['input'];
  point: Scalars['Int']['input'];
  status: PointExchangeHistoryStatus;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertSingleUserEducationRequest = {
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['String']['input']>;
  cumulative_grade?: InputMaybe<Scalars['String']['input']>;
  graduation_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<EducationLevel>;
  major: Scalars['String']['input'];
  school: Scalars['String']['input'];
  start_date: Scalars['Date']['input'];
};

export type UpsertSingleUserExperienceRequest = {
  company_name: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employment_type?: InputMaybe<EmploymentType>;
  end_date?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  location: Scalars['String']['input'];
  location_type?: InputMaybe<LocationType>;
  start_date: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type UpsertSingleUserFamilyRequest = {
  birthdate: Scalars['Date']['input'];
  city_id: Scalars['String']['input'];
  country_id: Scalars['String']['input'];
  created_at?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nationality_id: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  province_id: Scalars['String']['input'];
  relation: Relation;
  religion: Religion;
};

export type UpsertSingleUserHealthRequest = {
  created_at?: InputMaybe<Scalars['String']['input']>;
  explaination: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  status: HealthStatus;
  year: Scalars['Int']['input'];
};

export type UpsertUserEducationRequest = {
  request: Array<UpsertSingleUserEducationRequest>;
};

export type UpsertUserEducationResponse = {
  __typename?: 'UpsertUserEducationResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertUserExperienceRequest = {
  request: Array<UpsertSingleUserExperienceRequest>;
};

export type UpsertUserExperienceResponse = {
  __typename?: 'UpsertUserExperienceResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertUserFamilyRequest = {
  request: Array<UpsertSingleUserFamilyRequest>;
};

export type UpsertUserFamilyResponse = {
  __typename?: 'UpsertUserFamilyResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertUserHealthRequest = {
  request: Array<UpsertSingleUserHealthRequest>;
};

export type UpsertUserHealthResponse = {
  __typename?: 'UpsertUserHealthResponse';
  success: Scalars['Boolean']['output'];
};

export type UpsertUserStatusProfileRequest = {
  reason?: InputMaybe<Scalars['String']['input']>;
  status: StatusProfile;
  user_id: Scalars['String']['input'];
};

export type UpsertUserStatusProfileResponse = {
  __typename?: 'UpsertUserStatusProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  affiliated_user: Scalars['Int']['output'];
  created_at: Scalars['String']['output'];
  email: Scalars['String']['output'];
  handphone_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_testing: Scalars['Boolean']['output'];
  is_verified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  refferal_code?: Maybe<Scalars['String']['output']>;
  role: Scalars['Int']['output'];
  status_account: Scalars['String']['output'];
  user_affiliator_poin?: Maybe<UserAffiliatorPoin>;
  user_attachment: Array<Maybe<UserAttachment>>;
  user_education: Array<Maybe<UserEducation>>;
  user_experience: Array<Maybe<UserExperience>>;
  user_family: Array<Maybe<UserFamily>>;
  user_health: Array<Maybe<UserHealth>>;
  user_language: Array<Maybe<UserLanguage>>;
  user_personal_info?: Maybe<UserPersonalInfo>;
  user_status_profile?: Maybe<UserStatusProfile>;
};

export type UserAffiliatedCountResponse = {
  __typename?: 'UserAffiliatedCountResponse';
  poin_affiliator: Scalars['Int']['output'];
  user_affiliated: Scalars['Int']['output'];
  user_affiliated_applied: Scalars['Int']['output'];
  user_affiliated_hired: Scalars['Int']['output'];
};

export type UserAffiliatorPoin = {
  __typename?: 'UserAffiliatorPoin';
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  poin: Scalars['Int']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
};

export type UserAttachment = {
  __typename?: 'UserAttachment';
  attachment_type: AttachmentType;
  certificate_issuer?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
};

export type UserData = {
  __typename?: 'UserData';
  email: Scalars['String']['output'];
  handphone_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type UserEducation = {
  __typename?: 'UserEducation';
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  cumulative_grade?: Maybe<Scalars['String']['output']>;
  graduation_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  level?: Maybe<EducationLevel>;
  major: Scalars['String']['output'];
  school: Scalars['String']['output'];
  start_date?: Maybe<Scalars['Date']['output']>;
  user: User;
  user_id: Scalars['Int']['output'];
};

export type UserExperience = {
  __typename?: 'UserExperience';
  company_name: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employment_type?: Maybe<EmploymentType>;
  end_date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  location: Scalars['String']['output'];
  location_type?: Maybe<LocationType>;
  start_date?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
  user: User;
  user_id: Scalars['Int']['output'];
};

export type UserFamily = {
  __typename?: 'UserFamily';
  birthdate: Scalars['Date']['output'];
  city: GeoDbCity;
  city_id: Scalars['String']['output'];
  country: GeoDbCountry;
  country_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nationality: GeoDbCountry;
  nationality_id: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  province: GeoDbProvince;
  province_id: Scalars['String']['output'];
  relation: Relation;
  religion: Religion;
  user: User;
  user_id: Scalars['Int']['output'];
};

export type UserHealth = {
  __typename?: 'UserHealth';
  created_at: Scalars['String']['output'];
  explaination?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status: HealthStatus;
  user: User;
  user_id: Scalars['Int']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type UserLanguage = {
  __typename?: 'UserLanguage';
  created_at: Scalars['String']['output'];
  end_date?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language: Language;
  language_level?: Maybe<LanguageLevel>;
  start_date?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user: User;
  user_id: Scalars['Int']['output'];
};

export enum UserOtpSentBy {
  Whatsapp = 'Whatsapp'
}

export enum UserOtpType {
  AccountVerification = 'AccountVerification',
  Authentication = 'Authentication'
}

export type UserPersonalInfo = {
  __typename?: 'UserPersonalInfo';
  address: Scalars['String']['output'];
  age?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  blood_type?: Maybe<BloodType>;
  city: GeoDbCity;
  city_id: Scalars['String']['output'];
  country: GeoDbCountry;
  country_id: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  driver_license?: Maybe<DriverLicense>;
  gender?: Maybe<Gender>;
  height: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  is_ever_been_going_abroad: Scalars['Boolean']['output'];
  is_ever_proposing_passport: Scalars['Boolean']['output'];
  is_having_passport: Scalars['Boolean']['output'];
  is_single_child: Scalars['Boolean']['output'];
  jiko_pr?: Maybe<Scalars['String']['output']>;
  marital_status?: Maybe<MaritalStatus>;
  name: Scalars['String']['output'];
  name_hiragana?: Maybe<Scalars['String']['output']>;
  nationality: GeoDbCountry;
  nationality_id: Scalars['String']['output'];
  photo: Scalars['String']['output'];
  possible_duration_to_stay_in_japan?: Maybe<PossibleDurationToStayInJapan>;
  province: GeoDbProvince;
  province_id: Scalars['String']['output'];
  religion?: Maybe<Religion>;
  spouse_count?: Maybe<Scalars['Int']['output']>;
  spouse_responsibility?: Maybe<SpouseResponsibility>;
  user: User;
  user_id: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type UserProgress = {
  __typename?: 'UserProgress';
  reason?: Maybe<Scalars['String']['output']>;
  user_attachment: Scalars['Boolean']['output'];
  user_education: Scalars['Boolean']['output'];
  user_experience: Scalars['Boolean']['output'];
  user_family: Scalars['Boolean']['output'];
  user_health: Scalars['Boolean']['output'];
  user_language: Scalars['Boolean']['output'];
  user_personal_info: Scalars['Boolean']['output'];
  user_status_profile: StatusProfile;
};

export type UserStatusProfile = {
  __typename?: 'UserStatusProfile';
  approver_id?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status: StatusProfile;
  user_id: Scalars['Int']['output'];
};

export type VerifyOtpRequest = {
  otp: Scalars['String']['input'];
};

export type VerifyOtpResponse = {
  __typename?: 'VerifyOTPResponse';
  success: Scalars['Boolean']['output'];
};

export type ChangeStatusJobUserSelectionRequest = {
  job_user_selection_phase: UpdateStatusJobUserSelectionPhaseRequest;
};

export type ChangeStatusJobUserSelectionResponse = {
  __typename?: 'changeStatusJobUserSelectionResponse';
  success: Scalars['Boolean']['output'];
};

export type GenerateJapaneseCv = {
  __typename?: 'generateJapaneseCV';
  address_in_japanese: Scalars['String']['output'];
  cv_summary: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name_in_japanese: Scalars['String']['output'];
  phone_number: Scalars['String']['output'];
  summary_in_japanese: Scalars['String']['output'];
  user_attachment: Array<UserAttachment>;
  user_education: Array<UserEducation>;
  user_experience: Array<UserExperience>;
  user_language: Array<UserLanguage>;
  user_personal_info: UserPersonalInfo;
};

export type GetUserCvResponse = {
  __typename?: 'getUserCVResponse';
  address_in_kana?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name_in_kana?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type_cv: Scalars['String']['output'];
  user_id: Scalars['Int']['output'];
};

export type UpsertUserCvRequest = {
  address_in_kana?: InputMaybe<Scalars['String']['input']>;
  name_in_kana?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  type_cv: Scalars['String']['input'];
};

export type SearchUserParticipantQueryVariables = Exact<{
  request: SearchUserParticipantRequest;
}>;


export type SearchUserParticipantQuery = { __typename?: 'Query', searchUserParticipant: { __typename?: 'SearchUserParticipantResponse', data: Array<{ __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string } } | null, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string } | null>, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string } | null>, user_status_profile?: { __typename?: 'UserStatusProfile', id: number, user_id: number, status: StatusProfile, reason?: string | null, approver_id?: number | null, created_at: string } | null }> } };

export type SearchUserParticipantV2QueryVariables = Exact<{
  request: SearchUserParticipantRequestV2;
}>;


export type SearchUserParticipantV2Query = { __typename?: 'Query', searchUserParticipantV2: { __typename?: 'SearchUserParticipantResponseV2', pagination: { __typename?: 'Pagination', total: number, page: number, limit: number }, data: Array<{ __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string } } | null, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string } | null>, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string } | null>, user_status_profile?: { __typename?: 'UserStatusProfile', id: number, user_id: number, status: StatusProfile, reason?: string | null, approver_id?: number | null, created_at: string } | null }> } };

export type UpsertUserStatusProfileMutationVariables = Exact<{
  request: Array<UpsertUserStatusProfileRequest> | UpsertUserStatusProfileRequest;
}>;


export type UpsertUserStatusProfileMutation = { __typename?: 'Mutation', upsertUserStatusProfile: { __typename?: 'UpsertUserStatusProfileResponse', success: boolean } };

export type GetUserParticipantQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
}>;


export type GetUserParticipantQuery = { __typename?: 'Query', getUserParticipant: { __typename?: 'GetUserParticipantResponse', data: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } | null, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string } | null>, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string } | null>, user_health: Array<{ __typename?: 'UserHealth', id: number, user_id: number, status: HealthStatus, name?: string | null, year?: number | null, explaination?: string | null, created_at: string } | null>, user_family: Array<{ __typename?: 'UserFamily', id: number, user_id: number, name: string, relation: Relation, birthdate: string, country_id: string, province_id: string, city_id: string, religion: Religion, nationality_id: string, phone_number?: string | null, created_at: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } | null>, user_attachment: Array<{ __typename?: 'UserAttachment', id: number, user_id: number, attachment_type: AttachmentType, url: string, created_at: string } | null>, user_language: Array<{ __typename?: 'UserLanguage', id: number, user_id: number, language: Language, language_level?: LanguageLevel | null, url?: string | null, created_at: string } | null>, user_status_profile?: { __typename?: 'UserStatusProfile', id: number, user_id: number, status: StatusProfile, reason?: string | null, approver_id?: number | null, created_at: string } | null } } };

export type GetAffiliatorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAffiliatorQuery = { __typename?: 'Query', getAffiliator: Array<{ __typename?: 'User', id: number, name: string, email: string, refferal_code?: string | null, affiliated_user: number, user_affiliator_poin?: { __typename?: 'UserAffiliatorPoin', poin: number } | null }> };

export type UpsertAffiliatorMutationVariables = Exact<{
  request: UpsertAffiliatorRequest;
}>;


export type UpsertAffiliatorMutation = { __typename?: 'Mutation', upsertAffiliator: { __typename?: 'ResetPasswordResponse', success: boolean } };

export type DetailUserAffiliatedCountQueryVariables = Exact<{
  user_id: Scalars['Int']['input'];
  referralCode: Scalars['String']['input'];
}>;


export type DetailUserAffiliatedCountQuery = { __typename?: 'Query', detailUserAffiliatedCount: { __typename?: 'UserAffiliatedCountResponse', poin_affiliator: number, user_affiliated: number, user_affiliated_applied: number, user_affiliated_hired: number } };

export type ListUserAffiliatedQueryVariables = Exact<{
  referralCode: Scalars['String']['input'];
}>;


export type ListUserAffiliatedQuery = { __typename?: 'Query', listUserAffiliated: Array<{ __typename?: 'User', id: number, name: string, email: string, refferal_code?: string | null, affiliated_user: number, created_at: string, status_account: string, user_affiliator_poin?: { __typename?: 'UserAffiliatorPoin', poin: number } | null, user_status_profile?: { __typename?: 'UserStatusProfile', status: StatusProfile } | null }> };

export type GetListEwalletQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListEwalletQuery = { __typename?: 'Query', getListEwallet: Array<{ __typename?: 'EWallet', id: number, name: string, created_at: string }> };

export type GetPointExchangeHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointExchangeHistoryQuery = { __typename?: 'Query', getPointExchangeHistory: Array<{ __typename?: 'PointExchangeHistory', id: number, user_id: number, ewallet_id: number, point: number, status: PointExchangeHistoryStatus, no_hp: string, created_at: string, ewallet: { __typename?: 'EWallet', id: number, name: string, created_at: string }, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, is_testing: boolean, created_at: string, refferal_code?: string | null, affiliated_user: number } }> };

export type UpsertPoinExchangeHistoryMutationVariables = Exact<{
  data: UpsertPointExchangeHistoryInput;
}>;


export type UpsertPoinExchangeHistoryMutation = { __typename?: 'Mutation', upsertPoinExchangeHistory: { __typename?: 'ResetPasswordResponse', success: boolean } };

export type LoginMutationVariables = Exact<{
  request: LoginRequest;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', token: string, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean } } };

export type RegisterMutationVariables = Exact<{
  request: RegisterRequest;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'RegisterResponse', token: string, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean } } };

export type GoogleLoginMutationVariables = Exact<{
  request: GoogleLoginRequest;
}>;


export type GoogleLoginMutation = { __typename?: 'Mutation', googleLogin: { __typename?: 'GoogleLoginResponse', token: string, user: { __typename?: 'User', handphone_number?: string | null, role: number, is_verified: boolean } } };

export type VerifyOtpMutationVariables = Exact<{
  request: VerifyOtpRequest;
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOTP: { __typename?: 'VerifyOTPResponse', success: boolean } };

export type SendOtpMutationVariables = Exact<{
  request: SendOtpRequest;
}>;


export type SendOtpMutation = { __typename?: 'Mutation', sendOTP: { __typename?: 'SendOTPResponse', success: boolean } };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', getProfile: { __typename?: 'GetProfileResponse', user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, is_testing: boolean, refferal_code?: string | null } } };

export type SendResetLinkMutationVariables = Exact<{
  request: SendResetLinkRequest;
}>;


export type SendResetLinkMutation = { __typename?: 'Mutation', sendResetLink: { __typename?: 'SendResetLinkResponse', success: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  request: ResetPasswordRequest;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResponse', success: boolean } };

export type UpdatePhoneNumberMutationVariables = Exact<{
  request: UpdateUserRequest;
}>;


export type UpdatePhoneNumberMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserResponse', success: boolean } };

export type GetCountriesQueryVariables = Exact<{
  request: GetCountriesRequest;
}>;


export type GetCountriesQuery = { __typename?: 'Query', getCountries: { __typename?: 'GetCountriesResponse', data: Array<{ __typename?: 'GeoDBCountry', id: string, name: string }> } };

export type GetProvincesQueryVariables = Exact<{
  request: GetProvincesRequest;
}>;


export type GetProvincesQuery = { __typename?: 'Query', getProvinces: { __typename?: 'GetProvincesResponse', data: Array<{ __typename?: 'GeoDBProvince', id: string, name: string }> } };

export type GetCitiesQueryVariables = Exact<{
  request: GetCitiesRequest;
}>;


export type GetCitiesQuery = { __typename?: 'Query', getCities: { __typename?: 'GetCitiesResponse', data: Array<{ __typename?: 'GeoDBCity', id: string, name: string }> } };

export type JobListQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JobListQuery = { __typename?: 'Query', getJob: { __typename?: 'GetJobResponse', data: Array<{ __typename?: 'Job', id: number, created_at: string, updated_at: string, deleted_at?: string | null, title: string, job_company_id: number, min: number, max: number, salary_currency: string, salary_period: JobSalaryPeriod, description: string, type: JobType, location_city_id?: string | null, location_province_id?: string | null, location_country_id?: string | null, location_type: JobLocationType, is_active: boolean, is_bookmark: boolean, job_company?: { __typename?: 'JobCompany', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string, logo: string, size_from: number, size_to: number } | null, job_skills?: Array<{ __typename?: 'JobSkill', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, tags?: Array<{ __typename?: 'JobTag', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, categories?: Array<{ __typename?: 'JobCategory', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, job_selection_phase: Array<{ __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string } }> }> } };

export type JobDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobDetailQuery = { __typename?: 'Query', getJobDetail: { __typename?: 'GetJobDetailResponse', data?: { __typename?: 'Job', id: number, title: string, description: string, type: JobType, location_city_id?: string | null, location_province_id?: string | null, location_country_id?: string | null, location_type: JobLocationType, is_active: boolean, min: number, max: number, salary_currency: string, salary_period: JobSalaryPeriod, created_at: string, is_applied: boolean, city: { __typename?: 'GeoDBCity', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, country: { __typename?: 'GeoDBCountry', id: string, name: string }, job_skills?: Array<{ __typename?: 'JobSkill', id: number, name: string }> | null, job_company?: { __typename?: 'JobCompany', id: number, name: string, size_from: number, size_to: number } | null, categories?: Array<{ __typename?: 'JobCategory', id: number, name: string }> | null, tags?: Array<{ __typename?: 'JobTag', id: number, name: string }> | null, job_selection_phase: Array<{ __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string } }> } | null } };

export type JobUpsertMutationVariables = Exact<{
  request: UpsertJobRequest;
}>;


export type JobUpsertMutation = { __typename?: 'Mutation', upsertJob: { __typename?: 'UpsertJobResponse', success: boolean } };

export type JobDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobDeleteMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'DeleteJobResponse', success: boolean } };

export type JobCompanyListQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobCompanyListQuery = { __typename?: 'Query', getJobCompany: { __typename?: 'GetJobCompanyResponse', data: Array<{ __typename?: 'JobCompany', id: number, name: string, jobs?: Array<{ __typename?: 'Job', id: number, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string } }> | null }> } };

export type JobCompanyDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobCompanyDetailQuery = { __typename?: 'Query', getJobCompanyDetail: { __typename?: 'GetJobCompanyDetailResponse', data?: { __typename?: 'JobCompany', id: number, created_at: string, updated_at: string, name: string, logo: string, size_from: number, size_to: number } | null } };

export type JobCompanyDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobCompanyDeleteMutation = { __typename?: 'Mutation', deleteJobCompany: { __typename?: 'DeleteJobCompanyResponse', success: boolean } };

export type JobTagListQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobTagListQuery = { __typename?: 'Query', getJobTag: { __typename?: 'GetJobTagResponse', data: Array<{ __typename?: 'JobTag', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> } };

export type JobTagDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobTagDetailQuery = { __typename?: 'Query', getJobTagDetail: { __typename?: 'GetJobTagDetailResponse', data?: { __typename?: 'JobTag', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string } | null } };

export type JobTagUpsertMutationVariables = Exact<{
  request: UpsertJobTagRequest;
}>;


export type JobTagUpsertMutation = { __typename?: 'Mutation', upsertJobTag: { __typename?: 'UpsertJobTagResponse', success: boolean } };

export type JobTagDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobTagDeleteMutation = { __typename?: 'Mutation', deleteJobTag: { __typename?: 'DeleteJobTagResponse', success: boolean } };

export type JobSkillListQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobSkillListQuery = { __typename?: 'Query', getJobSkill: { __typename?: 'GetJobSkillResponse', data: Array<{ __typename?: 'JobSkill', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> } };

export type JobSkillDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobSkillDetailQuery = { __typename?: 'Query', getJobSkillDetail: { __typename?: 'GetJobSkillDetailResponse', data?: { __typename?: 'JobSkill', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string } | null } };

export type JobSkillUpsertMutationVariables = Exact<{
  request: UpsertJobSkillRequest;
}>;


export type JobSkillUpsertMutation = { __typename?: 'Mutation', upsertJobSkill: { __typename?: 'UpsertJobSkillResponse', success: boolean } };

export type JobSkillDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobSkillDeleteMutation = { __typename?: 'Mutation', deleteJobSkill: { __typename?: 'DeleteJobSkillResponse', success: boolean } };

export type JobCategoryListQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobCategoryListQuery = { __typename?: 'Query', getJobCategory: { __typename?: 'GetJobCategoryResponse', data: Array<{ __typename?: 'JobCategory', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> } };

export type JobCategoryDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobCategoryDetailQuery = { __typename?: 'Query', getJobCategoryDetail: { __typename?: 'GetJobCategoryDetailResponse', data?: { __typename?: 'JobCategory', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string } | null } };

export type JobCategoryUpsertMutationVariables = Exact<{
  request: UpsertJobCategoryRequest;
}>;


export type JobCategoryUpsertMutation = { __typename?: 'Mutation', upsertJobCategory: { __typename?: 'UpsertJobCategoryResponse', success: boolean } };

export type JobCategoryDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobCategoryDeleteMutation = { __typename?: 'Mutation', deleteJobCategory: { __typename?: 'DeleteJobCategoryResponse', success: boolean } };

export type JobMasterPhaseListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobMasterPhaseListQuery = { __typename?: 'Query', getMasterJobSelectionPhase: { __typename?: 'GetMasterJobSelectionPhaseResponse', data: Array<{ __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, phase: string, description: string }> } };

export type JobMasterPhaseDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobMasterPhaseDetailQuery = { __typename?: 'Query', getMasterJobSelectionPhaseDetail: { __typename?: 'GetMasterJobSelectionPhaseDetailResponse', data?: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, phase: string, description: string } | null } };

export type JobMasterPhaseUpsertMutationVariables = Exact<{
  request: UpsertMasterJobSelectionPhaseRequest;
}>;


export type JobMasterPhaseUpsertMutation = { __typename?: 'Mutation', upsertMasterJobSelectionPhase: { __typename?: 'UpsertMasterJobSelectionPhaseResponse', success: boolean } };

export type JobMasterPhaseDeleteMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type JobMasterPhaseDeleteMutation = { __typename?: 'Mutation', deleteMasterJobSelectionPhase: { __typename?: 'DeleteMasterJobSelectionPhaseResponse', success: boolean } };

export type ApplyJobMutationVariables = Exact<{
  request: ApplyJobRequest;
}>;


export type ApplyJobMutation = { __typename?: 'Mutation', applyJob: { __typename?: 'ApplyJobResponse', success: boolean } };

export type UpdateJobBookmarkMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
  value: Scalars['Boolean']['input'];
}>;


export type UpdateJobBookmarkMutation = { __typename?: 'Mutation', updateJobBookmark: { __typename?: 'BaseSuccessResponse', success: boolean } };

export type GetJobUserQueryVariables = Exact<{
  request: SearchUserParticipantRequest;
}>;


export type GetJobUserQuery = { __typename?: 'Query', getJobUser: { __typename?: 'GetJobUserResponse', data: Array<{ __typename?: 'JobUser', id: number, created_at: string, updated_at: string, deleted_at?: string | null, user_id: number, job_id: number, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, created_at: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } | null, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string } | null>, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string } | null>, user_status_profile?: { __typename?: 'UserStatusProfile', id: number, user_id: number, status: StatusProfile, reason?: string | null, approver_id?: number | null, created_at: string } | null, user_language: Array<{ __typename?: 'UserLanguage', id: number, user_id: number, language: Language, language_level?: LanguageLevel | null, url?: string | null, created_at: string, start_date?: string | null, end_date?: string | null } | null> }, job: { __typename?: 'Job', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_company_id: number, salary_currency: string, salary_period: JobSalaryPeriod, description: string, type: JobType, location_city_id?: string | null, location_province_id?: string | null, location_country_id?: string | null, location_type: JobLocationType, title: string, min: number, max: number, job_skills?: Array<{ __typename?: 'JobSkill', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, tags?: Array<{ __typename?: 'JobTag', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, job_company?: { __typename?: 'JobCompany', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string, logo: string, size_from: number, size_to: number } | null }, job_user_selection_phase: Array<{ __typename?: 'JobUserSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_id: number, status: JobUserSelectionPhaseStatus, url?: string | null, score?: number | null, job_selection_phase_id: number, coderbyte_metadata?: { __typename?: 'CoderByteMetadata', test_id: string, public_url: string } | null, job_selection_phase: { __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string, ai_cv_recommender: boolean, hrd_room: boolean } } }>, last_job_user_selection_phase?: { __typename?: 'JobUserSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_id: number, job_selection_phase_id: number, status: JobUserSelectionPhaseStatus, url?: string | null, score?: number | null, ai_recommender?: { __typename?: 'JobUserSelectionPhaseAIRecommender', is_recommended_by_ai: boolean, ai_score?: number | null, ai_notes?: string | null } | null, job_selection_phase: { __typename?: 'JobSelectionPhase', master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string, ai_cv_recommender: boolean, hrd_room: boolean } } } | null }> } };

export type GetJobUserDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobUserDetailQuery = { __typename?: 'Query', getJobUserDetail: { __typename?: 'GetJobUserDetailResponse', data?: { __typename?: 'JobUser', id: number, created_at: string, updated_at: string, deleted_at?: string | null, user_id: number, job_id: number, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, created_at: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } | null, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string } | null>, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string } | null>, user_health: Array<{ __typename?: 'UserHealth', id: number, user_id: number, status: HealthStatus, name?: string | null, year?: number | null, explaination?: string | null, created_at: string } | null>, user_family: Array<{ __typename?: 'UserFamily', id: number, user_id: number, name: string, relation: Relation, birthdate: string, country_id: string, province_id: string, city_id: string, religion: Religion, nationality_id: string, phone_number?: string | null, created_at: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } | null>, user_attachment: Array<{ __typename?: 'UserAttachment', id: number, user_id: number, attachment_type: AttachmentType, url: string, created_at: string } | null>, user_language: Array<{ __typename?: 'UserLanguage', id: number, user_id: number, language: Language, language_level?: LanguageLevel | null, url?: string | null, created_at: string } | null>, user_status_profile?: { __typename?: 'UserStatusProfile', id: number, user_id: number, status: StatusProfile, reason?: string | null, approver_id?: number | null, created_at: string } | null }, job: { __typename?: 'Job', id: number, created_at: string, updated_at: string, deleted_at?: string | null, title: string, job_company_id: number, min: number, max: number, salary_currency: string, salary_period: JobSalaryPeriod, description: string, type: JobType, location_city_id?: string | null, location_province_id?: string | null, location_country_id?: string | null, location_type: JobLocationType, job_skills?: Array<{ __typename?: 'JobSkill', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, tags?: Array<{ __typename?: 'JobTag', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, categories?: Array<{ __typename?: 'JobCategory', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string }> | null, job_company?: { __typename?: 'JobCompany', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string, logo: string, size_from: number, size_to: number } | null, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string } }, job_user_selection_phase: Array<{ __typename?: 'JobUserSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_id: number, status: JobUserSelectionPhaseStatus, url?: string | null, score?: number | null, job_selection_phase_id: number, coderbyte_metadata?: { __typename?: 'CoderByteMetadata', test_id: string, public_url: string } | null, job_selection_phase: { __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string, ai_cv_recommender: boolean, hrd_room: boolean } }, ai_recommender?: { __typename?: 'JobUserSelectionPhaseAIRecommender', is_recommended_by_ai: boolean, ai_score?: number | null, ai_notes?: string | null } | null, job_user_selection_phase_hrdroom?: { __typename?: 'JobUserSelectionPhaseHRDRoom', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_selection_phase_id: number, module_id: number, test_token: string, expired_at: string } | null }>, last_job_user_selection_phase?: { __typename?: 'JobUserSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_id: number, job_selection_phase_id: number, status: JobUserSelectionPhaseStatus, url?: string | null, score?: number | null, ai_recommender?: { __typename?: 'JobUserSelectionPhaseAIRecommender', is_recommended_by_ai: boolean, ai_score?: number | null, ai_notes?: string | null } | null, job_selection_phase: { __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string, ai_cv_recommender: boolean, hrd_room: boolean } }, job_user_selection_phase_hrdroom?: { __typename?: 'JobUserSelectionPhaseHRDRoom', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_selection_phase_id: number, module_id: number, test_token: string, expired_at: string } | null } | null } | null } };

export type GetStatusJobVacancyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatusJobVacancyUserQuery = { __typename?: 'Query', getStatusJobVacancyUser?: { __typename?: 'GetJobUserDetailResponse', data?: { __typename?: 'JobUser', id: number, created_at: string, updated_at: string, deleted_at?: string | null, user_id: number, job_id: number, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean, user_personal_info?: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, created_at: string } | null }, job: { __typename?: 'Job', id: number, created_at: string, updated_at: string, deleted_at?: string | null, title: string, job_company_id: number, min: number, max: number, salary_currency: string, salary_period: JobSalaryPeriod, description: string, type: JobType, location_city_id?: string | null, location_province_id?: string | null, location_country_id?: string | null, location_type: JobLocationType, job_company?: { __typename?: 'JobCompany', id: number, created_at: string, updated_at: string, deleted_at?: string | null, name: string, logo: string, size_from: number, size_to: number } | null }, job_user_selection_phase: Array<{ __typename?: 'JobUserSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_id: number, job_selection_phase_id: number, status: JobUserSelectionPhaseStatus, url?: string | null, score?: number | null, coderbyte_metadata?: { __typename?: 'CoderByteMetadata', test_id: string, public_url: string } | null, job_selection_phase: { __typename?: 'JobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_id: number, phase_number: number, master_job_selection_phase_id: number, required_application_document: Array<string | null>, master_job_selection_phase: { __typename?: 'MasterJobSelectionPhase', id: number, created_at: string, updated_at: string, deleted_at?: string | null, phase: string, description: string } }, job_user_selection_phase_hrdroom?: { __typename?: 'JobUserSelectionPhaseHRDRoom', id: number, created_at: string, updated_at: string, deleted_at?: string | null, job_user_selection_phase_id: number, module_id: number, test_token: string, expired_at: string, url?: string | null } | null }> } | null } | null };

export type ChangeStatusJobUserSelectionMutationVariables = Exact<{
  request: ChangeStatusJobUserSelectionRequest;
}>;


export type ChangeStatusJobUserSelectionMutation = { __typename?: 'Mutation', changeStatusJobUserSelection: { __typename?: 'changeStatusJobUserSelectionResponse', success: boolean } };

export type HrdroomGetModulesQueryVariables = Exact<{ [key: string]: never; }>;


export type HrdroomGetModulesQuery = { __typename?: 'Query', hrdroomGetModules: { __typename?: 'GetHRDRoomModulesResponse', data: Array<{ __typename?: 'HRDRoomModule', id: number, name: string, published: string, created_at: string, updated_at: string }> } };

export type HrdroomGetTestsQueryVariables = Exact<{
  module_id: Scalars['Int']['input'];
}>;


export type HrdroomGetTestsQuery = { __typename?: 'Query', hrdroomGetTests: { __typename?: 'GetHRDRoomGetActivationCodeResponse', data: Array<{ __typename?: 'HRDRoomGetActivationCode', id: number, name: string, description: string, quantity: number, module_id: number, module_name: string, start_from: string, expired_at?: string | null, created_at: string, updated_at: string, created_by: string, status: string, campaign: number, geo_location: number }> } };

export type SentHrdRoomTestTokenMutationVariables = Exact<{
  request: SentHrdRoomTestTokenRequest;
}>;


export type SentHrdRoomTestTokenMutation = { __typename?: 'Mutation', sentHRDRoomTestToken: { __typename?: 'SentHRDRoomTestTokenResponse', success: boolean } };

export type GetJobUserSelectionPhaseHrdRoomQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetJobUserSelectionPhaseHrdRoomQuery = { __typename?: 'Query', getJobUserSelectionPhaseHRDRoom: { __typename?: 'GetJobUserSelectionPhaseHRDRoomResponse', data: { __typename?: 'JobUserSelectionPhaseHRDRoom', id: number, created_at: string, updated_at: string, deleted_at?: string | null, module_id: number, test_token: string, expired_at: string, url?: string | null, job_user_selection_phase_id: number, module?: { __typename?: 'HRDRoomModule', id: number, name: string, published: string, created_at: string, updated_at: string } | null, activation_code?: { __typename?: 'HRDRoomGetActivationCode', id: number, name: string, description: string, quantity: number, module_id: number, module_name: string, start_from: string, expired_at?: string | null, created_at: string, updated_at: string, created_by: string, status: string, campaign: number, geo_location: number } | null, test?: { __typename?: 'HRDRoomGetActivationCodeDetail', token: string, status: string, score: number, selection_status: string, name: string } | null } } };

export type JobUsersPageQueryVariables = Exact<{
  req: JobUsersPageReq;
}>;


export type JobUsersPageQuery = { __typename?: 'Query', jobUsersPage: { __typename?: 'JobUsersPageRes', page: { __typename?: 'PageInfo', page: number, size: number, total: number }, data: Array<{ __typename?: 'JobUserPreview', id: number, userId: number, name: string, email: string, title: string, companyId: number, companyName: string, aiRecommender?: { __typename?: 'JobUserSelectionPhaseAIRecommender', is_recommended_by_ai: boolean, ai_score?: number | null, ai_notes?: string | null } | null }> } };

export type JobHistoryUserQueryVariables = Exact<{ [key: string]: never; }>;


export type JobHistoryUserQuery = { __typename?: 'Query', jobHistoryUser: { __typename?: 'JobHistoryUserResponse', data: Array<{ __typename?: 'JobHistoryUser', id: number, company: string, position: string, partnerType: string, appliedDate: string, status: string, currentStage: string, currentStep: number, totalSteps: number }> } };

export type GetUserPersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPersonalInfoQuery = { __typename?: 'Query', getUserPersonalInfo: { __typename?: 'GetUserPersonalInfoResponse', data: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, created_at: string, name_hiragana?: string | null, age?: number | null, spouse_responsibility?: SpouseResponsibility | null, spouse_count?: number | null, jiko_pr?: string | null, possible_duration_to_stay_in_japan?: PossibleDurationToStayInJapan | null, user: { __typename?: 'User', id: number, name: string, email: string, handphone_number?: string | null, role: number, is_verified: boolean }, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } } } };

export type UpsertUserEducationMutationVariables = Exact<{
  request: UpsertUserEducationRequest;
}>;


export type UpsertUserEducationMutation = { __typename?: 'Mutation', upsertUserEducation: { __typename?: 'UpsertUserEducationResponse', success: boolean } };

export type GetUserEducationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEducationQuery = { __typename?: 'Query', getUserEducation: { __typename?: 'GetUserEducationResponse', data: Array<{ __typename?: 'UserEducation', id: number, school: string, level?: EducationLevel | null, major: string, country?: string | null, cumulative_grade?: string | null, start_date?: string | null, graduation_date?: string | null, created_at: string, user_id: number }> } };

export type UpsertUserExperienceMutationVariables = Exact<{
  request: UpsertUserExperienceRequest;
}>;


export type UpsertUserExperienceMutation = { __typename?: 'Mutation', upsertUserExperience: { __typename?: 'UpsertUserExperienceResponse', success: boolean } };

export type GetUserExperienceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserExperienceQuery = { __typename?: 'Query', getUserExperience: { __typename?: 'GetUserExperienceResponse', data: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, description?: string | null, created_at: string }> } };

export type UpsertUserHealthMutationVariables = Exact<{
  request: UpsertUserHealthRequest;
}>;


export type UpsertUserHealthMutation = { __typename?: 'Mutation', upsertUserHealth: { __typename?: 'UpsertUserHealthResponse', success: boolean } };

export type GetUserHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserHealthQuery = { __typename?: 'Query', getUserHealth: { __typename?: 'GetUserHealthResponse', data: Array<{ __typename?: 'UserHealth', id: number, user_id: number, status: HealthStatus, name?: string | null, year?: number | null, explaination?: string | null, created_at: string }> } };

export type UpsertUserFamilyMutationVariables = Exact<{
  request: UpsertUserFamilyRequest;
}>;


export type UpsertUserFamilyMutation = { __typename?: 'Mutation', upsertUserFamily: { __typename?: 'UpsertUserFamilyResponse', success: boolean } };

export type GetUserFamilyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFamilyQuery = { __typename?: 'Query', getUserFamily: { __typename?: 'GetUserFamilyResponse', data: Array<{ __typename?: 'UserFamily', id: number, user_id: number, name: string, relation: Relation, birthdate: string, country_id: string, province_id: string, city_id: string, religion: Religion, nationality_id: string, phone_number?: string | null, created_at: string, country: { __typename?: 'GeoDBCountry', id: string, name: string }, province: { __typename?: 'GeoDBProvince', id: string, name: string }, city: { __typename?: 'GeoDBCity', id: string, name: string }, nationality: { __typename?: 'GeoDBCountry', id: string, name: string } }> } };

export type GetUserAttachmentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAttachmentQuery = { __typename?: 'Query', getUserAttachment: { __typename?: 'GetUserAttachmentResponse', data: Array<{ __typename?: 'UserAttachment', id: number, user_id: number, attachment_type: AttachmentType, url: string, name?: string | null, certificate_issuer?: string | null, score?: number | null, created_at: string, start_date?: string | null, end_date?: string | null }> } };

export type GetUserLanguageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLanguageQuery = { __typename?: 'Query', getUserLanguage: { __typename?: 'GetUserLanguageResponse', data: Array<{ __typename?: 'UserLanguage', id: number, user_id: number, language: Language, language_level?: LanguageLevel | null, url?: string | null, created_at: string, start_date?: string | null, end_date?: string | null }> } };

export type GetUserResumeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserResumeQuery = { __typename?: 'Query', getUserResume: { __typename?: 'GetUserResumeResponse', data?: { __typename?: 'UserAttachment', id: number, user_id: number, attachment_type: AttachmentType, url: string, created_at: string } | null } };

export type GetUserProgressQueryVariables = Exact<{
  is_simplify?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserProgressQuery = { __typename?: 'Query', getUserProgress: { __typename?: 'GetUserProgressResponse', data: { __typename?: 'UserProgress', user_personal_info: boolean, user_education: boolean, user_experience: boolean, user_health: boolean, user_family: boolean, user_attachment: boolean, user_language: boolean, user_status_profile: StatusProfile, reason?: string | null } } };

export type ResubmitUserStatusProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type ResubmitUserStatusProfileMutation = { __typename?: 'Mutation', resubmitUserStatusProfile: { __typename?: 'ResubmitUserStatusProfileResponse', success: boolean } };

export type GenerateJapaneseCvQueryVariables = Exact<{ [key: string]: never; }>;


export type GenerateJapaneseCvQuery = { __typename?: 'Query', generateJapaneseCV: { __typename?: 'generateJapaneseCV', cv_summary: string, name_in_japanese: string, address_in_japanese: string, summary_in_japanese: string, phone_number: string, email: string, user_personal_info: { __typename?: 'UserPersonalInfo', id: number, user_id: number, name: string, address: string, birthdate?: string | null, country_id: string, province_id: string, city_id: string, gender?: Gender | null, is_single_child: boolean, marital_status?: MaritalStatus | null, religion?: Religion | null, nationality_id: string, driver_license?: DriverLicense | null, blood_type?: BloodType | null, height: number, weight: number, is_ever_been_going_abroad: boolean, is_having_passport: boolean, is_ever_proposing_passport: boolean, photo: string, created_at: string }, user_experience: Array<{ __typename?: 'UserExperience', id: number, user_id: number, title: string, company_name: string, employment_type?: EmploymentType | null, start_date?: string | null, end_date?: string | null, location: string, location_type?: LocationType | null, created_at: string }>, user_attachment: Array<{ __typename?: 'UserAttachment', id: number, user_id: number, attachment_type: AttachmentType, url: string, created_at: string }>, user_education: Array<{ __typename?: 'UserEducation', id: number, user_id: number, school: string, level?: EducationLevel | null, major: string, start_date?: string | null, graduation_date?: string | null, created_at: string }> } };

export type GetUserCvQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCvQuery = { __typename?: 'Query', getUserCV: { __typename?: 'getUserCVResponse', id: number, user_id: number, name_in_kana?: string | null, address_in_kana?: string | null, summary?: string | null, created_at: string, type_cv: string } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const SearchUserParticipantDocument = new TypedDocumentString(`
    query SearchUserParticipant($request: SearchUserParticipantRequest!) {
  searchUserParticipant(request: $request) {
    data {
      id
      name
      email
      handphone_number
      role
      is_verified
      user_personal_info {
        id
        user_id
        name
        address
        birthdate
        country_id
        province_id
        city_id
        gender
        is_single_child
        marital_status
        religion
        nationality_id
        driver_license
        blood_type
        height
        weight
        is_ever_been_going_abroad
        is_having_passport
        is_ever_proposing_passport
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
      }
      user_experience {
        id
        user_id
        title
        company_name
        employment_type
        start_date
        end_date
        location
        location_type
        created_at
      }
      user_education {
        id
        user_id
        school
        level
        major
        start_date
        graduation_date
        created_at
      }
      user_status_profile {
        id
        user_id
        status
        reason
        approver_id
        created_at
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchUserParticipantQuery, SearchUserParticipantQueryVariables>;
export const SearchUserParticipantV2Document = new TypedDocumentString(`
    query SearchUserParticipantV2($request: SearchUserParticipantRequestV2!) {
  searchUserParticipantV2(request: $request) {
    pagination {
      total
      page
      limit
    }
    data {
      id
      name
      email
      handphone_number
      role
      is_verified
      user_personal_info {
        id
        user_id
        name
        address
        birthdate
        country_id
        province_id
        city_id
        gender
        is_single_child
        marital_status
        religion
        nationality_id
        driver_license
        blood_type
        height
        weight
        is_ever_been_going_abroad
        is_having_passport
        is_ever_proposing_passport
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
      }
      user_experience {
        id
        user_id
        title
        company_name
        employment_type
        start_date
        end_date
        location
        location_type
        created_at
      }
      user_education {
        id
        user_id
        school
        level
        major
        start_date
        graduation_date
        created_at
      }
      user_status_profile {
        id
        user_id
        status
        reason
        approver_id
        created_at
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchUserParticipantV2Query, SearchUserParticipantV2QueryVariables>;
export const UpsertUserStatusProfileDocument = new TypedDocumentString(`
    mutation UpsertUserStatusProfile($request: [UpsertUserStatusProfileRequest!]!) {
  upsertUserStatusProfile(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertUserStatusProfileMutation, UpsertUserStatusProfileMutationVariables>;
export const GetUserParticipantDocument = new TypedDocumentString(`
    query GetUserParticipant($user_id: Int!) {
  getUserParticipant(user_id: $user_id) {
    data {
      id
      name
      email
      handphone_number
      role
      is_verified
      user_personal_info {
        id
        user_id
        name
        address
        birthdate
        country_id
        province_id
        city_id
        gender
        is_single_child
        marital_status
        religion
        nationality_id
        driver_license
        blood_type
        height
        weight
        is_ever_been_going_abroad
        is_having_passport
        is_ever_proposing_passport
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
        photo
        nationality {
          id
          name
        }
      }
      user_education {
        id
        user_id
        school
        level
        major
        start_date
        graduation_date
        created_at
      }
      user_experience {
        id
        user_id
        title
        company_name
        employment_type
        start_date
        end_date
        location
        location_type
        created_at
      }
      user_health {
        id
        user_id
        status
        name
        year
        explaination
        created_at
      }
      user_family {
        id
        user_id
        name
        relation
        birthdate
        country_id
        province_id
        city_id
        religion
        nationality_id
        phone_number
        created_at
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
        nationality {
          id
          name
        }
      }
      user_attachment {
        id
        user_id
        attachment_type
        url
        created_at
      }
      user_language {
        id
        user_id
        language
        language_level
        url
        created_at
      }
      user_status_profile {
        id
        user_id
        status
        reason
        approver_id
        created_at
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserParticipantQuery, GetUserParticipantQueryVariables>;
export const GetAffiliatorDocument = new TypedDocumentString(`
    query GetAffiliator {
  getAffiliator {
    id
    name
    email
    refferal_code
    affiliated_user
    user_affiliator_poin {
      poin
    }
  }
}
    `) as unknown as TypedDocumentString<GetAffiliatorQuery, GetAffiliatorQueryVariables>;
export const UpsertAffiliatorDocument = new TypedDocumentString(`
    mutation UpsertAffiliator($request: UpsertAffiliatorRequest!) {
  upsertAffiliator(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertAffiliatorMutation, UpsertAffiliatorMutationVariables>;
export const DetailUserAffiliatedCountDocument = new TypedDocumentString(`
    query DetailUserAffiliatedCount($user_id: Int!, $referralCode: String!) {
  detailUserAffiliatedCount(user_id: $user_id, refferal_code: $referralCode) {
    poin_affiliator
    user_affiliated
    user_affiliated_applied
    user_affiliated_hired
  }
}
    `) as unknown as TypedDocumentString<DetailUserAffiliatedCountQuery, DetailUserAffiliatedCountQueryVariables>;
export const ListUserAffiliatedDocument = new TypedDocumentString(`
    query ListUserAffiliated($referralCode: String!) {
  listUserAffiliated(refferal_code: $referralCode) {
    id
    name
    email
    refferal_code
    affiliated_user
    created_at
    user_affiliator_poin {
      poin
    }
    user_status_profile {
      status
    }
    status_account
  }
}
    `) as unknown as TypedDocumentString<ListUserAffiliatedQuery, ListUserAffiliatedQueryVariables>;
export const GetListEwalletDocument = new TypedDocumentString(`
    query GetListEwallet {
  getListEwallet {
    id
    name
    created_at
  }
}
    `) as unknown as TypedDocumentString<GetListEwalletQuery, GetListEwalletQueryVariables>;
export const GetPointExchangeHistoryDocument = new TypedDocumentString(`
    query GetPointExchangeHistory {
  getPointExchangeHistory {
    id
    user_id
    ewallet_id
    point
    status
    no_hp
    created_at
    ewallet {
      id
      name
      created_at
    }
    user {
      id
      name
      email
      handphone_number
      role
      is_verified
      is_testing
      created_at
      refferal_code
      affiliated_user
    }
  }
}
    `) as unknown as TypedDocumentString<GetPointExchangeHistoryQuery, GetPointExchangeHistoryQueryVariables>;
export const UpsertPoinExchangeHistoryDocument = new TypedDocumentString(`
    mutation UpsertPoinExchangeHistory($data: UpsertPointExchangeHistoryInput!) {
  upsertPoinExchangeHistory(data: $data) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertPoinExchangeHistoryMutation, UpsertPoinExchangeHistoryMutationVariables>;
export const LoginDocument = new TypedDocumentString(`
    mutation Login($request: LoginRequest!) {
  login(request: $request) {
    token
    user {
      id
      name
      email
      handphone_number
      role
      is_verified
    }
  }
}
    `) as unknown as TypedDocumentString<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = new TypedDocumentString(`
    mutation Register($request: RegisterRequest!) {
  register(request: $request) {
    token
    user {
      id
      name
      email
      handphone_number
      role
      is_verified
    }
  }
}
    `) as unknown as TypedDocumentString<RegisterMutation, RegisterMutationVariables>;
export const GoogleLoginDocument = new TypedDocumentString(`
    mutation GoogleLogin($request: GoogleLoginRequest!) {
  googleLogin(request: $request) {
    token
    user {
      handphone_number
      role
      is_verified
    }
  }
}
    `) as unknown as TypedDocumentString<GoogleLoginMutation, GoogleLoginMutationVariables>;
export const VerifyOtpDocument = new TypedDocumentString(`
    mutation VerifyOTP($request: VerifyOTPRequest!) {
  verifyOTP(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const SendOtpDocument = new TypedDocumentString(`
    mutation SendOTP($request: SendOTPRequest!) {
  sendOTP(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<SendOtpMutation, SendOtpMutationVariables>;
export const GetProfileDocument = new TypedDocumentString(`
    query GetProfile {
  getProfile {
    user {
      id
      name
      email
      handphone_number
      role
      is_verified
      is_testing
      refferal_code
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfileQuery, GetProfileQueryVariables>;
export const SendResetLinkDocument = new TypedDocumentString(`
    mutation SendResetLink($request: SendResetLinkRequest!) {
  sendResetLink(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<SendResetLinkMutation, SendResetLinkMutationVariables>;
export const ResetPasswordDocument = new TypedDocumentString(`
    mutation ResetPassword($request: ResetPasswordRequest!) {
  resetPassword(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdatePhoneNumberDocument = new TypedDocumentString(`
    mutation UpdatePhoneNumber($request: UpdateUserRequest!) {
  updateUser(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdatePhoneNumberMutation, UpdatePhoneNumberMutationVariables>;
export const GetCountriesDocument = new TypedDocumentString(`
    query GetCountries($request: GetCountriesRequest!) {
  getCountries(request: $request) {
    data {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetProvincesDocument = new TypedDocumentString(`
    query GetProvinces($request: GetProvincesRequest!) {
  getProvinces(request: $request) {
    data {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetProvincesQuery, GetProvincesQueryVariables>;
export const GetCitiesDocument = new TypedDocumentString(`
    query GetCities($request: GetCitiesRequest!) {
  getCities(request: $request) {
    data {
      id
      name
    }
  }
}
    `) as unknown as TypedDocumentString<GetCitiesQuery, GetCitiesQueryVariables>;
export const JobListDocument = new TypedDocumentString(`
    query JobList($title: String, $isActive: Boolean) {
  getJob(title: $title, is_active: $isActive) {
    data {
      id
      created_at
      updated_at
      deleted_at
      title
      job_company_id
      min
      max
      salary_currency
      salary_period
      description
      type
      location_city_id
      location_province_id
      location_country_id
      location_type
      is_active
      job_company {
        id
        created_at
        updated_at
        deleted_at
        name
        logo
        size_from
        size_to
      }
      job_skills {
        id
        created_at
        updated_at
        deleted_at
        name
      }
      tags {
        id
        created_at
        updated_at
        deleted_at
        name
      }
      categories {
        id
        created_at
        updated_at
        deleted_at
        name
      }
      country {
        id
        name
      }
      province {
        id
        name
      }
      city {
        id
        name
      }
      job_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_id
        phase_number
        master_job_selection_phase_id
        required_application_document
        master_job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          phase
          description
        }
      }
      is_bookmark
    }
  }
}
    `) as unknown as TypedDocumentString<JobListQuery, JobListQueryVariables>;
export const JobDetailDocument = new TypedDocumentString(`
    query JobDetail($id: Int!) {
  getJobDetail(id: $id) {
    data {
      id
      title
      description
      type
      location_city_id
      location_province_id
      location_country_id
      location_type
      is_active
      city {
        id
        name
      }
      province {
        id
        name
      }
      country {
        id
        name
      }
      job_skills {
        id
        name
      }
      job_company {
        id
        name
        size_from
        size_to
      }
      job_skills {
        id
        name
      }
      categories {
        id
        name
      }
      tags {
        id
        name
      }
      job_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_id
        phase_number
        master_job_selection_phase_id
        required_application_document
        master_job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          phase
          description
        }
      }
      min
      max
      salary_currency
      salary_period
      created_at
      is_applied
    }
  }
}
    `) as unknown as TypedDocumentString<JobDetailQuery, JobDetailQueryVariables>;
export const JobUpsertDocument = new TypedDocumentString(`
    mutation JobUpsert($request: UpsertJobRequest!) {
  upsertJob(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobUpsertMutation, JobUpsertMutationVariables>;
export const JobDeleteDocument = new TypedDocumentString(`
    mutation JobDelete($id: Int!) {
  deleteJob(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobDeleteMutation, JobDeleteMutationVariables>;
export const JobCompanyListDocument = new TypedDocumentString(`
    query JobCompanyList($name: String) {
  getJobCompany(name: $name) {
    data {
      id
      name
      jobs {
        id
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<JobCompanyListQuery, JobCompanyListQueryVariables>;
export const JobCompanyDetailDocument = new TypedDocumentString(`
    query JobCompanyDetail($id: Int!) {
  getJobCompanyDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      name
      logo
      size_from
      size_to
    }
  }
}
    `) as unknown as TypedDocumentString<JobCompanyDetailQuery, JobCompanyDetailQueryVariables>;
export const JobCompanyDeleteDocument = new TypedDocumentString(`
    mutation JobCompanyDelete($id: Int!) {
  deleteJobCompany(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobCompanyDeleteMutation, JobCompanyDeleteMutationVariables>;
export const JobTagListDocument = new TypedDocumentString(`
    query JobTagList($name: String) {
  getJobTag(name: $name) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobTagListQuery, JobTagListQueryVariables>;
export const JobTagDetailDocument = new TypedDocumentString(`
    query JobTagDetail($id: Int!) {
  getJobTagDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobTagDetailQuery, JobTagDetailQueryVariables>;
export const JobTagUpsertDocument = new TypedDocumentString(`
    mutation JobTagUpsert($request: UpsertJobTagRequest!) {
  upsertJobTag(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobTagUpsertMutation, JobTagUpsertMutationVariables>;
export const JobTagDeleteDocument = new TypedDocumentString(`
    mutation JobTagDelete($id: Int!) {
  deleteJobTag(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobTagDeleteMutation, JobTagDeleteMutationVariables>;
export const JobSkillListDocument = new TypedDocumentString(`
    query JobSkillList($name: String) {
  getJobSkill(name: $name) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobSkillListQuery, JobSkillListQueryVariables>;
export const JobSkillDetailDocument = new TypedDocumentString(`
    query JobSkillDetail($id: Int!) {
  getJobSkillDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobSkillDetailQuery, JobSkillDetailQueryVariables>;
export const JobSkillUpsertDocument = new TypedDocumentString(`
    mutation JobSkillUpsert($request: UpsertJobSkillRequest!) {
  upsertJobSkill(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobSkillUpsertMutation, JobSkillUpsertMutationVariables>;
export const JobSkillDeleteDocument = new TypedDocumentString(`
    mutation JobSkillDelete($id: Int!) {
  deleteJobSkill(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobSkillDeleteMutation, JobSkillDeleteMutationVariables>;
export const JobCategoryListDocument = new TypedDocumentString(`
    query JobCategoryList($name: String) {
  getJobCategory(name: $name) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobCategoryListQuery, JobCategoryListQueryVariables>;
export const JobCategoryDetailDocument = new TypedDocumentString(`
    query JobCategoryDetail($id: Int!) {
  getJobCategoryDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      deleted_at
      name
    }
  }
}
    `) as unknown as TypedDocumentString<JobCategoryDetailQuery, JobCategoryDetailQueryVariables>;
export const JobCategoryUpsertDocument = new TypedDocumentString(`
    mutation JobCategoryUpsert($request: UpsertJobCategoryRequest!) {
  upsertJobCategory(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobCategoryUpsertMutation, JobCategoryUpsertMutationVariables>;
export const JobCategoryDeleteDocument = new TypedDocumentString(`
    mutation JobCategoryDelete($id: Int!) {
  deleteJobCategory(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobCategoryDeleteMutation, JobCategoryDeleteMutationVariables>;
export const JobMasterPhaseListDocument = new TypedDocumentString(`
    query JobMasterPhaseList {
  getMasterJobSelectionPhase {
    data {
      id
      created_at
      updated_at
      phase
      description
    }
  }
}
    `) as unknown as TypedDocumentString<JobMasterPhaseListQuery, JobMasterPhaseListQueryVariables>;
export const JobMasterPhaseDetailDocument = new TypedDocumentString(`
    query JobMasterPhaseDetail($id: Int!) {
  getMasterJobSelectionPhaseDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      phase
      description
    }
  }
}
    `) as unknown as TypedDocumentString<JobMasterPhaseDetailQuery, JobMasterPhaseDetailQueryVariables>;
export const JobMasterPhaseUpsertDocument = new TypedDocumentString(`
    mutation JobMasterPhaseUpsert($request: UpsertMasterJobSelectionPhaseRequest!) {
  upsertMasterJobSelectionPhase(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobMasterPhaseUpsertMutation, JobMasterPhaseUpsertMutationVariables>;
export const JobMasterPhaseDeleteDocument = new TypedDocumentString(`
    mutation JobMasterPhaseDelete($id: Int!) {
  deleteMasterJobSelectionPhase(id: $id) {
    success
  }
}
    `) as unknown as TypedDocumentString<JobMasterPhaseDeleteMutation, JobMasterPhaseDeleteMutationVariables>;
export const ApplyJobDocument = new TypedDocumentString(`
    mutation ApplyJob($request: ApplyJobRequest!) {
  applyJob(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<ApplyJobMutation, ApplyJobMutationVariables>;
export const UpdateJobBookmarkDocument = new TypedDocumentString(`
    mutation UpdateJobBookmark($jobId: Int!, $value: Boolean!) {
  updateJobBookmark(jobId: $jobId, value: $value) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpdateJobBookmarkMutation, UpdateJobBookmarkMutationVariables>;
export const GetJobUserDocument = new TypedDocumentString(`
    query GetJobUser($request: SearchUserParticipantRequest!) {
  getJobUser(search: $request) {
    data {
      id
      created_at
      updated_at
      deleted_at
      user_id
      job_id
      user {
        id
        name
        email
        handphone_number
        role
        is_verified
        user_personal_info {
          id
          user_id
          name
          address
          birthdate
          country_id
          province_id
          city_id
          gender
          is_single_child
          marital_status
          religion
          nationality_id
          driver_license
          blood_type
          height
          weight
          is_ever_been_going_abroad
          is_having_passport
          is_ever_proposing_passport
          photo
          created_at
          country {
            id
            name
          }
          province {
            id
            name
          }
          city {
            id
            name
          }
          nationality {
            id
            name
          }
        }
        user_education {
          id
          user_id
          school
          level
          major
          start_date
          graduation_date
          created_at
        }
        user_experience {
          id
          user_id
          title
          company_name
          employment_type
          start_date
          end_date
          location
          location_type
          created_at
        }
        user_status_profile {
          id
          user_id
          status
          reason
          approver_id
          created_at
        }
        user_language {
          id
          user_id
          language
          language_level
          url
          created_at
          start_date
          end_date
        }
      }
      job {
        id
        created_at
        updated_at
        deleted_at
        job_company_id
        salary_currency
        salary_period
        description
        type
        location_city_id
        location_province_id
        location_country_id
        location_type
        title
        job_skills {
          id
          created_at
          updated_at
          deleted_at
          name
        }
        tags {
          id
          created_at
          updated_at
          deleted_at
          name
        }
        job_company {
          id
          created_at
          updated_at
          deleted_at
          name
          logo
          size_from
          size_to
        }
        min
        max
      }
      job_user_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_user_id
        status
        url
        score
        coderbyte_metadata {
          test_id
          public_url
        }
        job_selection_phase_id
        job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          job_id
          phase_number
          master_job_selection_phase_id
          required_application_document
          master_job_selection_phase {
            id
            created_at
            updated_at
            deleted_at
            phase
            description
            ai_cv_recommender
            hrd_room
          }
        }
      }
      last_job_user_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_user_id
        job_selection_phase_id
        status
        url
        score
        ai_recommender {
          is_recommended_by_ai
          ai_score
          ai_notes
        }
        job_selection_phase {
          master_job_selection_phase {
            id
            created_at
            updated_at
            deleted_at
            phase
            description
            ai_cv_recommender
            hrd_room
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetJobUserQuery, GetJobUserQueryVariables>;
export const GetJobUserDetailDocument = new TypedDocumentString(`
    query GetJobUserDetail($id: Int!) {
  getJobUserDetail(id: $id) {
    data {
      id
      created_at
      updated_at
      deleted_at
      user_id
      job_id
      user {
        id
        name
        email
        handphone_number
        role
        is_verified
        user_personal_info {
          id
          user_id
          name
          address
          birthdate
          country_id
          province_id
          city_id
          gender
          is_single_child
          marital_status
          religion
          nationality_id
          driver_license
          blood_type
          height
          weight
          is_ever_been_going_abroad
          is_having_passport
          is_ever_proposing_passport
          photo
          created_at
          country {
            id
            name
          }
          province {
            id
            name
          }
          city {
            id
            name
          }
          nationality {
            id
            name
          }
        }
        user_education {
          id
          user_id
          school
          level
          major
          start_date
          graduation_date
          created_at
        }
        user_experience {
          id
          user_id
          title
          company_name
          employment_type
          start_date
          end_date
          location
          location_type
          created_at
        }
        user_health {
          id
          user_id
          status
          name
          year
          explaination
          created_at
        }
        user_family {
          id
          user_id
          name
          relation
          birthdate
          country_id
          province_id
          city_id
          religion
          nationality_id
          phone_number
          created_at
          country {
            id
            name
          }
          province {
            id
            name
          }
          city {
            id
            name
          }
          nationality {
            id
            name
          }
        }
        user_attachment {
          id
          user_id
          attachment_type
          url
          created_at
        }
        user_language {
          id
          user_id
          language
          language_level
          url
          created_at
        }
        user_status_profile {
          id
          user_id
          status
          reason
          approver_id
          created_at
        }
      }
      job {
        id
        created_at
        updated_at
        deleted_at
        title
        job_company_id
        min
        max
        salary_currency
        salary_period
        description
        type
        location_city_id
        location_province_id
        location_country_id
        location_type
        job_skills {
          id
          created_at
          updated_at
          deleted_at
          name
        }
        tags {
          id
          created_at
          updated_at
          deleted_at
          name
        }
        categories {
          id
          created_at
          updated_at
          deleted_at
          name
        }
        job_company {
          id
          created_at
          updated_at
          deleted_at
          name
          logo
          size_from
          size_to
        }
        country {
          id
          name
        }
        province {
          id
          name
        }
        city {
          id
          name
        }
      }
      job_user_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_user_id
        status
        url
        score
        coderbyte_metadata {
          test_id
          public_url
        }
        job_selection_phase_id
        job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          job_id
          phase_number
          master_job_selection_phase_id
          required_application_document
          master_job_selection_phase {
            id
            created_at
            updated_at
            deleted_at
            phase
            description
            ai_cv_recommender
            hrd_room
          }
        }
        ai_recommender {
          is_recommended_by_ai
          ai_score
          ai_notes
        }
        job_user_selection_phase_hrdroom {
          id
          created_at
          updated_at
          deleted_at
          job_user_selection_phase_id
          module_id
          test_token
          expired_at
        }
      }
      last_job_user_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_user_id
        job_selection_phase_id
        status
        url
        score
        ai_recommender {
          is_recommended_by_ai
          ai_score
          ai_notes
        }
        job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          job_id
          phase_number
          master_job_selection_phase_id
          required_application_document
          master_job_selection_phase {
            id
            created_at
            updated_at
            deleted_at
            phase
            description
            ai_cv_recommender
            hrd_room
          }
        }
        job_user_selection_phase_hrdroom {
          id
          created_at
          updated_at
          deleted_at
          job_user_selection_phase_id
          module_id
          test_token
          expired_at
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetJobUserDetailQuery, GetJobUserDetailQueryVariables>;
export const GetStatusJobVacancyUserDocument = new TypedDocumentString(`
    query GetStatusJobVacancyUser {
  getStatusJobVacancyUser {
    data {
      id
      created_at
      updated_at
      deleted_at
      user_id
      job_id
      user {
        id
        name
        email
        handphone_number
        role
        is_verified
        user_personal_info {
          id
          user_id
          name
          address
          birthdate
          country_id
          province_id
          city_id
          gender
          is_single_child
          marital_status
          religion
          nationality_id
          driver_license
          blood_type
          height
          weight
          is_ever_been_going_abroad
          is_having_passport
          is_ever_proposing_passport
          photo
          created_at
        }
      }
      job {
        id
        created_at
        updated_at
        deleted_at
        title
        job_company_id
        min
        max
        salary_currency
        salary_period
        description
        type
        location_city_id
        location_province_id
        location_country_id
        location_type
        job_company {
          id
          created_at
          updated_at
          deleted_at
          name
          logo
          size_from
          size_to
        }
      }
      job_user_selection_phase {
        id
        created_at
        updated_at
        deleted_at
        job_user_id
        job_selection_phase_id
        status
        url
        score
        coderbyte_metadata {
          test_id
          public_url
        }
        job_selection_phase {
          id
          created_at
          updated_at
          deleted_at
          job_id
          phase_number
          master_job_selection_phase_id
          required_application_document
          master_job_selection_phase {
            id
            created_at
            updated_at
            deleted_at
            phase
            description
          }
        }
        job_user_selection_phase_hrdroom {
          id
          created_at
          updated_at
          deleted_at
          job_user_selection_phase_id
          module_id
          test_token
          expired_at
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatusJobVacancyUserQuery, GetStatusJobVacancyUserQueryVariables>;
export const ChangeStatusJobUserSelectionDocument = new TypedDocumentString(`
    mutation ChangeStatusJobUserSelection($request: changeStatusJobUserSelectionRequest!) {
  changeStatusJobUserSelection(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<ChangeStatusJobUserSelectionMutation, ChangeStatusJobUserSelectionMutationVariables>;
export const HrdroomGetModulesDocument = new TypedDocumentString(`
    query HrdroomGetModules {
  hrdroomGetModules {
    data {
      id
      name
      published
      created_at
      updated_at
    }
  }
}
    `) as unknown as TypedDocumentString<HrdroomGetModulesQuery, HrdroomGetModulesQueryVariables>;
export const HrdroomGetTestsDocument = new TypedDocumentString(`
    query HrdroomGetTests($module_id: Int!) {
  hrdroomGetTests(module_id: $module_id) {
    data {
      id
      name
      description
      quantity
      module_id
      module_name
      start_from
      expired_at
      created_at
      updated_at
      created_by
      status
      campaign
      geo_location
    }
  }
}
    `) as unknown as TypedDocumentString<HrdroomGetTestsQuery, HrdroomGetTestsQueryVariables>;
export const SentHrdRoomTestTokenDocument = new TypedDocumentString(`
    mutation SentHRDRoomTestToken($request: SentHRDRoomTestTokenRequest!) {
  sentHRDRoomTestToken(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<SentHrdRoomTestTokenMutation, SentHrdRoomTestTokenMutationVariables>;
export const GetJobUserSelectionPhaseHrdRoomDocument = new TypedDocumentString(`
    query GetJobUserSelectionPhaseHRDRoom($id: Int!) {
  getJobUserSelectionPhaseHRDRoom(id: $id) {
    data {
      id
      created_at
      updated_at
      deleted_at
      module_id
      test_token
      expired_at
      url
      job_user_selection_phase_id
      module {
        id
        name
        published
        created_at
        updated_at
      }
      activation_code {
        id
        name
        description
        quantity
        module_id
        module_name
        start_from
        expired_at
        created_at
        updated_at
        created_by
        status
        campaign
        geo_location
      }
      test {
        token
        status
        score
        selection_status
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetJobUserSelectionPhaseHrdRoomQuery, GetJobUserSelectionPhaseHrdRoomQueryVariables>;
export const JobUsersPageDocument = new TypedDocumentString(`
    query JobUsersPage($req: JobUsersPageReq!) {
  jobUsersPage(req: $req) {
    page {
      page
      size
      total
    }
    data {
      id
      userId
      name
      email
      title
      companyId
      companyName
      aiRecommender {
        is_recommended_by_ai
        ai_score
        ai_notes
      }
    }
  }
}
    `) as unknown as TypedDocumentString<JobUsersPageQuery, JobUsersPageQueryVariables>;
export const JobHistoryUserDocument = new TypedDocumentString(`
    query JobHistoryUser {
  jobHistoryUser {
    data {
      id
      company
      position
      partnerType
      appliedDate
      status
      currentStage
      currentStep
      totalSteps
    }
  }
}
    `) as unknown as TypedDocumentString<JobHistoryUserQuery, JobHistoryUserQueryVariables>;
export const GetUserPersonalInfoDocument = new TypedDocumentString(`
    query GetUserPersonalInfo {
  getUserPersonalInfo {
    data {
      id
      user_id
      name
      address
      birthdate
      country_id
      province_id
      city_id
      gender
      is_single_child
      marital_status
      religion
      nationality_id
      driver_license
      blood_type
      height
      weight
      is_ever_been_going_abroad
      is_having_passport
      is_ever_proposing_passport
      photo
      created_at
      user {
        id
        name
        email
        handphone_number
        role
        is_verified
      }
      country {
        id
        name
      }
      province {
        id
        name
      }
      city {
        id
        name
      }
      nationality {
        id
        name
      }
      name_hiragana
      age
      spouse_responsibility
      spouse_count
      jiko_pr
      possible_duration_to_stay_in_japan
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserPersonalInfoQuery, GetUserPersonalInfoQueryVariables>;
export const UpsertUserEducationDocument = new TypedDocumentString(`
    mutation UpsertUserEducation($request: UpsertUserEducationRequest!) {
  upsertUserEducation(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertUserEducationMutation, UpsertUserEducationMutationVariables>;
export const GetUserEducationDocument = new TypedDocumentString(`
    query GetUserEducation {
  getUserEducation {
    data {
      id
      school
      level
      major
      country
      cumulative_grade
      start_date
      graduation_date
      created_at
      user_id
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserEducationQuery, GetUserEducationQueryVariables>;
export const UpsertUserExperienceDocument = new TypedDocumentString(`
    mutation UpsertUserExperience($request: UpsertUserExperienceRequest!) {
  upsertUserExperience(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertUserExperienceMutation, UpsertUserExperienceMutationVariables>;
export const GetUserExperienceDocument = new TypedDocumentString(`
    query GetUserExperience {
  getUserExperience {
    data {
      id
      user_id
      title
      company_name
      employment_type
      start_date
      end_date
      location
      location_type
      description
      created_at
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserExperienceQuery, GetUserExperienceQueryVariables>;
export const UpsertUserHealthDocument = new TypedDocumentString(`
    mutation UpsertUserHealth($request: UpsertUserHealthRequest!) {
  upsertUserHealth(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertUserHealthMutation, UpsertUserHealthMutationVariables>;
export const GetUserHealthDocument = new TypedDocumentString(`
    query GetUserHealth {
  getUserHealth {
    data {
      id
      user_id
      status
      name
      year
      explaination
      created_at
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserHealthQuery, GetUserHealthQueryVariables>;
export const UpsertUserFamilyDocument = new TypedDocumentString(`
    mutation UpsertUserFamily($request: UpsertUserFamilyRequest!) {
  upsertUserFamily(request: $request) {
    success
  }
}
    `) as unknown as TypedDocumentString<UpsertUserFamilyMutation, UpsertUserFamilyMutationVariables>;
export const GetUserFamilyDocument = new TypedDocumentString(`
    query GetUserFamily {
  getUserFamily {
    data {
      id
      user_id
      name
      relation
      birthdate
      country_id
      province_id
      city_id
      religion
      nationality_id
      phone_number
      created_at
      country {
        id
        name
      }
      province {
        id
        name
      }
      city {
        id
        name
      }
      nationality {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserFamilyQuery, GetUserFamilyQueryVariables>;
export const GetUserAttachmentDocument = new TypedDocumentString(`
    query GetUserAttachment {
  getUserAttachment {
    data {
      id
      user_id
      attachment_type
      url
      name
      certificate_issuer
      score
      created_at
      start_date
      end_date
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserAttachmentQuery, GetUserAttachmentQueryVariables>;
export const GetUserLanguageDocument = new TypedDocumentString(`
    query GetUserLanguage {
  getUserLanguage {
    data {
      id
      user_id
      language
      language_level
      url
      created_at
      start_date
      end_date
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserLanguageQuery, GetUserLanguageQueryVariables>;
export const GetUserResumeDocument = new TypedDocumentString(`
    query GetUserResume {
  getUserResume {
    data {
      id
      user_id
      attachment_type
      url
      created_at
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserResumeQuery, GetUserResumeQueryVariables>;
export const GetUserProgressDocument = new TypedDocumentString(`
    query GetUserProgress($is_simplify: Boolean) {
  getUserProgress(is_simplify: $is_simplify) {
    data {
      user_personal_info
      user_education
      user_experience
      user_health
      user_family
      user_attachment
      user_language
      user_status_profile
      reason
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserProgressQuery, GetUserProgressQueryVariables>;
export const ResubmitUserStatusProfileDocument = new TypedDocumentString(`
    mutation ResubmitUserStatusProfile {
  resubmitUserStatusProfile {
    success
  }
}
    `) as unknown as TypedDocumentString<ResubmitUserStatusProfileMutation, ResubmitUserStatusProfileMutationVariables>;
export const GenerateJapaneseCvDocument = new TypedDocumentString(`
    query GenerateJapaneseCV {
  generateJapaneseCV {
    cv_summary
    name_in_japanese
    address_in_japanese
    summary_in_japanese
    phone_number
    user_personal_info {
      id
      user_id
      name
      address
      birthdate
      country_id
      province_id
      city_id
      gender
      is_single_child
      marital_status
      religion
      nationality_id
      driver_license
      blood_type
      height
      weight
      is_ever_been_going_abroad
      is_having_passport
      is_ever_proposing_passport
      photo
      created_at
    }
    user_experience {
      id
      user_id
      title
      company_name
      employment_type
      start_date
      end_date
      location
      location_type
      created_at
    }
    email
    user_attachment {
      id
      user_id
      attachment_type
      url
      created_at
    }
    user_education {
      id
      user_id
      school
      level
      major
      start_date
      graduation_date
      created_at
    }
  }
}
    `) as unknown as TypedDocumentString<GenerateJapaneseCvQuery, GenerateJapaneseCvQueryVariables>;
export const GetUserCvDocument = new TypedDocumentString(`
    query GetUserCV {
  getUserCV {
    id
    user_id
    name_in_kana
    address_in_kana
    summary
    created_at
    type_cv
  }
}
    `) as unknown as TypedDocumentString<GetUserCvQuery, GetUserCvQueryVariables>;